export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: any; output: any; }
  /** A slightly refined version of RFC-3339 compliant DateTime Scalar */
  DateTime: { input: any; output: any; }
  Double: { input: any; output: any; }
  /** A JSON scalar */
  JSON: { input: any; output: any; }
  /** A 64-bit signed integer */
  Long: { input: any; output: any; }
  /** An object scalar */
  Object: { input: any; output: any; }
  /** A custom scalar that represents files */
  Upload: { input: any; output: any; }
};

export type Agreement = {
  __typename?: 'Agreement';
  code?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
};

export type AgreementQueryCriteria = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AlertTypeEnum {
  Fcm = 'FCM',
  PasswordReset = 'PASSWORD_RESET',
  RequestNeeded = 'REQUEST_NEEDED'
}

export type ApiCredential = {
  __typename?: 'ApiCredential';
  accessKey?: Maybe<Scalars['String']['output']>;
  activeAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  merchantGuid?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Array<Maybe<AppPermDfn>>>;
  status?: Maybe<Scalars['String']['output']>;
  transactionalUser?: Maybe<AppLoginSubject>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ApiCredentialFilterRq = {
  activeAt?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: Status;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type ApiCredentialFilterRs = {
  __typename?: 'ApiCredentialFilterRs';
  data?: Maybe<Array<Maybe<ApiCredential>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type ApiCredentialPrivate = {
  __typename?: 'ApiCredentialPrivate';
  guid?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
};

export type ApiCredentialRole = {
  __typename?: 'ApiCredentialRole';
  apiCredentialGuid?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  roleGuid?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ApiCredentialRoleFilterRq = {
  apiCredentialGuid?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  roleGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type ApiCredentialSpecialFilter = {
  accessKey?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppLoginPrincipal = {
  __typename?: 'AppLoginPrincipal';
  /**  ... date time when user created */
  createdDate?: Maybe<Scalars['Date']['output']>;
  /**  ... user creadential */
  credential?: Maybe<Scalars['String']['output']>;
  /**  ... user principal identifier */
  guid?: Maybe<Scalars['String']['output']>;
  /**  ... user principal id to store email or phone number */
  principalId?: Maybe<Scalars['String']['output']>;
  /**  ... user principal type [EMAIL_USERNAME, MOBILE_USERNAME] */
  principalType?: Maybe<Scalars['String']['output']>;
  /**  ... data version */
  revision?: Maybe<Scalars['String']['output']>;
  /**  ... user valid date end */
  sourcePlatform?: Maybe<SourcePlatform>;
  /**  ... user status */
  status?: Maybe<PrincipalStatus>;
  /**  ... date time when user last updated */
  updatedDate?: Maybe<Scalars['Date']['output']>;
  /**  ... user valid date end */
  validDateEnd?: Maybe<Scalars['Date']['output']>;
  /**  ... user valid date */
  validDateStart?: Maybe<Scalars['Date']['output']>;
};

export type AppLoginRole = {
  __typename?: 'AppLoginRole';
  code?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<AppLoginSubject>;
  createdDate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Status>;
  updatedBy?: Maybe<AppLoginSubject>;
  updatedDate?: Maybe<Scalars['String']['output']>;
};

export type AppLoginSubject = {
  __typename?: 'AppLoginSubject';
  /**  ... user extension */
  appLoginExt?: Maybe<Array<Maybe<AppLoginSubjectExt>>>;
  /**  ... user principal */
  appLoginPrincipal?: Maybe<Array<Maybe<AppLoginPrincipal>>>;
  /**  ... date with format YYYY-MM-DD */
  birthday?: Maybe<Scalars['String']['output']>;
  /**  ... user category */
  category?: Maybe<Scalars['String']['output']>;
  /**  ... user company if any */
  company?: Maybe<Company>;
  /**  ... date time when user created */
  createdDate?: Maybe<Scalars['String']['output']>;
  /**  ... user gender */
  gender?: Maybe<Gender>;
  /**  ... user unique identifier */
  guid?: Maybe<Scalars['String']['output']>;
  merchants?: Maybe<Array<Maybe<Merchant>>>;
  /**  ... user full name */
  name?: Maybe<Scalars['String']['output']>;
  /**  ... data version */
  revision?: Maybe<Scalars['String']['output']>;
  /**  ... user roles */
  roles?: Maybe<Array<Maybe<AppLoginRole>>>;
  /**  ... soure platfrom where user registered */
  sourcePlatform?: Maybe<SourcePlatform>;
  /**  ... user status */
  status?: Maybe<Status>;
  /**  ... date time when user last updated */
  updatedDate?: Maybe<Scalars['String']['output']>;
};

/** AppLoginSubject Connection */
export type AppLoginSubjectConnection = {
  __typename?: 'AppLoginSubjectConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<AppLoginSubjectEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** AppLoginSubject Edge */
export type AppLoginSubjectEdge = {
  __typename?: 'AppLoginSubjectEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Field node */
  node?: Maybe<AppLoginSubject>;
};

export type AppLoginSubjectExt = {
  __typename?: 'AppLoginSubjectExt';
  /**  ... date time when extension created */
  createdDate?: Maybe<Scalars['String']['output']>;
  /**  ... user extension code */
  extCode?: Maybe<Scalars['String']['output']>;
  /**  ... user extension option */
  extOption?: Maybe<Scalars['String']['output']>;
  /**  ... user extension type */
  extType?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FetchFileResponse>;
  /**  ... unique user extension identifier */
  guid?: Maybe<Scalars['String']['output']>;
  /**  ... user guid to link column */
  loginSubjectGuid?: Maybe<Scalars['String']['output']>;
  /**  ... user extension parameter code */
  paramCode?: Maybe<Scalars['String']['output']>;
  /**  ... user extension parameter name */
  paramName?: Maybe<Scalars['String']['output']>;
  /**  ... user extension parameter type */
  paramType?: Maybe<Scalars['String']['output']>;
  /**  ... data version */
  revision?: Maybe<Scalars['String']['output']>;
  /**  ... user extension status */
  status?: Maybe<Status>;
  /**  ... date time when extension last updated */
  updatedDate?: Maybe<Scalars['String']['output']>;
  /**  ... can store datetime value */
  valueDatetime?: Maybe<Scalars['String']['output']>;
  /**  ... can store file value */
  valueFile?: Maybe<Scalars['String']['output']>;
  /**  ... can store json value */
  valueJson?: Maybe<Scalars['String']['output']>;
  /**  ... can store numeric value */
  valueNumeric?: Maybe<Scalars['Int']['output']>;
  /**  ... can store string value */
  valueString?: Maybe<Scalars['String']['output']>;
};

export type AppLoginSubjectExtRq = {
  /**  ... user extension code */
  extCode?: InputMaybe<Scalars['String']['input']>;
  /**  ... user extension option */
  extOption?: InputMaybe<Scalars['String']['input']>;
  /**  ... user extension type */
  extType?: InputMaybe<Scalars['String']['input']>;
  /**  ... user extension parameter code */
  paramCode?: InputMaybe<Scalars['String']['input']>;
  /**  ... user extension parameter name */
  paramName?: InputMaybe<Scalars['String']['input']>;
  /**  ... user extension parameter type */
  paramType?: InputMaybe<Scalars['String']['input']>;
  /**  ... can store datetime value */
  valueDatetime?: InputMaybe<Scalars['String']['input']>;
  /**  ... can store file value */
  valueFile?: InputMaybe<Scalars['String']['input']>;
  /**  ... can store json value */
  valueJson?: InputMaybe<Scalars['String']['input']>;
  /**  ... can store numeric value */
  valueNumeric?: InputMaybe<Scalars['Int']['input']>;
  /**  ... can store string value */
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export enum AppLoginSubjectSortByEnum {
  CreatedDate = 'createdDate',
  UpdatedDate = 'updatedDate'
}

export type AppPermDfn = {
  __typename?: 'AppPermDfn';
  createdBy?: Maybe<AppLoginSubject>;
  createdDate?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  permCode?: Maybe<Scalars['String']['output']>;
  permDescription?: Maybe<Scalars['String']['output']>;
  permModule?: Maybe<Scalars['String']['output']>;
  permName?: Maybe<Scalars['String']['output']>;
  permScope?: Maybe<Scalars['String']['output']>;
  permType?: Maybe<Scalars['String']['output']>;
  relatedMf?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Status>;
  updatedBy?: Maybe<AppLoginSubject>;
  updatedDate?: Maybe<Scalars['String']['output']>;
};

export type ApplyVacancyRq = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  vacancyGuid?: InputMaybe<Scalars['String']['input']>;
};

export type Approval = {
  __typename?: 'Approval';
  approvalGroup?: Maybe<ApprovalGroup>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  entityGuid?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  sourcePlatform?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ApprovalStatusEnum>;
  type?: Maybe<ApprovalTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  urlToCall?: Maybe<Scalars['String']['output']>;
};

export type ApprovalCriteria = {
  approvalGroupGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  approvalGroupName?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Array<Scalars['String']['input']>>;
  entityGuid?: InputMaybe<Array<Scalars['String']['input']>>;
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  permission?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  sourcePlatform?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<ApprovalStatusEnum>>;
  type?: InputMaybe<Array<ApprovalTypeEnum>>;
};

export type ApprovalGroup = {
  __typename?: 'ApprovalGroup';
  UpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum ApprovalStatusEnum {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export enum ApprovalTypeEnum {
  Creation = 'CREATION',
  Deletion = 'DELETION',
  Linkage = 'LINKAGE',
  Unlink = 'UNLINK',
  Update = 'UPDATE'
}

export type AssignTierToMember = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  memberGuid?: InputMaybe<Scalars['String']['input']>;
  tierGuid?: InputMaybe<Scalars['String']['input']>;
};

export type AttachPermRq = {
  /**  permission identifier */
  permsGuid: Array<InputMaybe<Scalars['String']['input']>>;
  /**  role identifier */
  roleGuid: Scalars['String']['input'];
};

export type AuditTag = {
  __typename?: 'AuditTag';
  createdAt?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  relatedEntity?: Maybe<Scalars['String']['output']>;
  tagKey: Scalars['String']['output'];
  tagValue?: Maybe<Scalars['String']['output']>;
};

export enum AuditTagEnum {
  AuthMsCredentialCreate = 'AUTH_MS_CREDENTIAL_CREATE',
  AuthMsCredentialDelete = 'AUTH_MS_CREDENTIAL_DELETE',
  AuthMsCredentialToRoleLink = 'AUTH_MS_CREDENTIAL_TO_ROLE_LINK',
  AuthMsCredentialToRoleLinkCredentialNotFound = 'AUTH_MS_CREDENTIAL_TO_ROLE_LINK_CREDENTIAL_NOT_FOUND',
  AuthMsCredentialToRoleLinkRoleNotFound = 'AUTH_MS_CREDENTIAL_TO_ROLE_LINK_ROLE_NOT_FOUND',
  AuthMsCredentialToRoleUnlink = 'AUTH_MS_CREDENTIAL_TO_ROLE_UNLINK',
  AuthMsCredentialToRoleUnlinkCredentialNotFound = 'AUTH_MS_CREDENTIAL_TO_ROLE_UNLINK_CREDENTIAL_NOT_FOUND',
  AuthMsCredentialToRoleUnlinkCredentialRoleLinkNotFound = 'AUTH_MS_CREDENTIAL_TO_ROLE_UNLINK_CREDENTIAL_ROLE_LINK_NOT_FOUND',
  AuthMsCredentialToRoleUnlinkRoleNotFound = 'AUTH_MS_CREDENTIAL_TO_ROLE_UNLINK_ROLE_NOT_FOUND',
  AuthMsCredentialUpdate = 'AUTH_MS_CREDENTIAL_UPDATE',
  AuthMsPermissionCreate = 'AUTH_MS_PERMISSION_CREATE',
  AuthMsPermissionCreatePermissionAlreadyExists = 'AUTH_MS_PERMISSION_CREATE_PERMISSION_ALREADY_EXISTS',
  AuthMsPermissionDelete = 'AUTH_MS_PERMISSION_DELETE',
  AuthMsPermissionDeletePermissionNotFound = 'AUTH_MS_PERMISSION_DELETE_PERMISSION_NOT_FOUND',
  AuthMsPermissionDeleteRoleAttached = 'AUTH_MS_PERMISSION_DELETE_ROLE_ATTACHED',
  AuthMsPermissionImport = 'AUTH_MS_PERMISSION_IMPORT',
  AuthMsPermissionToRoleLink = 'AUTH_MS_PERMISSION_TO_ROLE_LINK',
  AuthMsPermissionToRoleLinkPermissionAlreadyExists = 'AUTH_MS_PERMISSION_TO_ROLE_LINK_PERMISSION_ALREADY_EXISTS',
  AuthMsPermissionToRoleLinkPermissionEmpty = 'AUTH_MS_PERMISSION_TO_ROLE_LINK_PERMISSION_EMPTY',
  AuthMsPermissionToRoleLinkRoleNotFound = 'AUTH_MS_PERMISSION_TO_ROLE_LINK_ROLE_NOT_FOUND',
  AuthMsPermissionToRoleUnlink = 'AUTH_MS_PERMISSION_TO_ROLE_UNLINK',
  AuthMsPermissionToRoleUnlinkPermissionEmpty = 'AUTH_MS_PERMISSION_TO_ROLE_UNLINK_PERMISSION_EMPTY',
  AuthMsPermissionToRoleUnlinkPermissionNotFound = 'AUTH_MS_PERMISSION_TO_ROLE_UNLINK_PERMISSION_NOT_FOUND',
  AuthMsPermissionToRoleUnlinkRoleNotFound = 'AUTH_MS_PERMISSION_TO_ROLE_UNLINK_ROLE_NOT_FOUND',
  AuthMsPermissionUpdate = 'AUTH_MS_PERMISSION_UPDATE',
  AuthMsPermissionUpdatePermissionNotFound = 'AUTH_MS_PERMISSION_UPDATE_PERMISSION_NOT_FOUND',
  AuthMsRoleCreate = 'AUTH_MS_ROLE_CREATE',
  AuthMsRoleCreateRoleAlreadyExists = 'AUTH_MS_ROLE_CREATE_ROLE_ALREADY_EXISTS',
  AuthMsRoleDelete = 'AUTH_MS_ROLE_DELETE',
  AuthMsRoleDeleteRoleAttached = 'AUTH_MS_ROLE_DELETE_ROLE_ATTACHED',
  AuthMsRoleDeleteRoleNotFound = 'AUTH_MS_ROLE_DELETE_ROLE_NOT_FOUND',
  AuthMsRoleUpdate = 'AUTH_MS_ROLE_UPDATE',
  AuthMsRoleUpdateRoleNotFound = 'AUTH_MS_ROLE_UPDATE_ROLE_NOT_FOUND',
  AuthMsUserLogin = 'AUTH_MS_USER_LOGIN',
  AuthMsUserLoginPasswordNotMatch = 'AUTH_MS_USER_LOGIN_PASSWORD_NOT_MATCH',
  AuthMsUserLoginUserNotConfirmed = 'AUTH_MS_USER_LOGIN_USER_NOT_CONFIRMED',
  AuthMsUserLoginUserNotFound = 'AUTH_MS_USER_LOGIN_USER_NOT_FOUND',
  AuthMsUserLoginUserNotRegistered = 'AUTH_MS_USER_LOGIN_USER_NOT_REGISTERED',
  AuthMsUserLogout = 'AUTH_MS_USER_LOGOUT',
  AuthMsUserToRoleLink = 'AUTH_MS_USER_TO_ROLE_LINK',
  AuthMsUserToRoleLinkRoleNotFound = 'AUTH_MS_USER_TO_ROLE_LINK_ROLE_NOT_FOUND',
  AuthMsUserToRoleLinkUserNotFound = 'AUTH_MS_USER_TO_ROLE_LINK_USER_NOT_FOUND',
  AuthMsUserToRoleUnlink = 'AUTH_MS_USER_TO_ROLE_UNLINK',
  AuthMsUserToRoleUnlinkRolesToUsersNotFound = 'AUTH_MS_USER_TO_ROLE_UNLINK_ROLES_TO_USERS_NOT_FOUND',
  AuthMsUserToRoleUnlinkRoleNotFound = 'AUTH_MS_USER_TO_ROLE_UNLINK_ROLE_NOT_FOUND',
  AuthMsUserToRoleUnlinkUserNotFound = 'AUTH_MS_USER_TO_ROLE_UNLINK_USER_NOT_FOUND',
  ProductMsProductCreate = 'PRODUCT_MS_PRODUCT_CREATE',
  ProductMsProductUpdate = 'PRODUCT_MS_PRODUCT_UPDATE',
  ProductMsProductUpdateProductNotFound = 'PRODUCT_MS_PRODUCT_UPDATE_PRODUCT_NOT_FOUND'
}

export type AuditTagRq = {
  relatedEntity?: InputMaybe<Scalars['String']['input']>;
  tagKey: Scalars['String']['input'];
  tagValue?: InputMaybe<Scalars['String']['input']>;
};

export type AuditTrail = {
  __typename?: 'AuditTrail';
  action?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  codeLine?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  isActionTaken?: Maybe<Scalars['Boolean']['output']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']['output']>;
  merchantGuid?: Maybe<Scalars['String']['output']>;
  msSource?: Maybe<Scalars['String']['output']>;
  sourceIp?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<AuditTag>>>;
  user?: Maybe<AppLoginSubject>;
};

export type AuditTrailCriteria = {
  /**  ... audit action */
  action?: InputMaybe<Scalars['String']['input']>;
  /**  ... class in microservice that send audit */
  class?: InputMaybe<Scalars['String']['input']>;
  /**  ... code line in microservice that send audit */
  codeLine?: InputMaybe<Scalars['String']['input']>;
  /**  ... country code */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /**  ... audit description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**  ... function in microservice that send audit */
  function?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  /**  ... merchant guid */
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  /**  ... microservice where audit from */
  msSource?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /**  ... related enitity changes */
  relatedEntities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  /**  ... user ip that make changes */
  sourceIp?: InputMaybe<Scalars['String']['input']>;
  /**  ... tags key */
  tagKeys?: InputMaybe<Array<InputMaybe<AuditTagEnum>>>;
  /**  ... tags value */
  tagValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  ... user guid that make changes */
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type AuthSettings = {
  __typename?: 'AuthSettings';
  /**  ... Setting code */
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /**  ... user that create this setting */
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  /**  ... Setting identifier */
  guid?: Maybe<Scalars['String']['output']>;
  /**  ... Setting name */
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  /**  ... last user that update this setting */
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
  /**  ... Setting value */
  value?: Maybe<Scalars['String']['output']>;
};

export type AuthSettingsFilter = {
  code?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AuthSettingsWithFilterRs = {
  __typename?: 'AuthSettingsWithFilterRs';
  data?: Maybe<Array<Maybe<AuthSettings>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type AuthorHistoricalSlug = {
  __typename?: 'AuthorHistoricalSlug';
  cmsUserGuid?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type AuthorHistoricalSlugCriteria = {
  guid?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorHistoricalSlugResult = {
  __typename?: 'AuthorHistoricalSlugResult';
  data: Array<Maybe<AuthorHistoricalSlug>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type BirthdayTierBonusRule = {
  __typename?: 'BirthdayTierBonusRule';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tierGuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BirthdayTierBonusRuleTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type BirthdayTierBonusRuleCriteria = {
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: Scalars['String']['input'];
  tierGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<BirthdayTierBonusRuleTypeEnum>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum BirthdayTierBonusRuleTypeEnum {
  Fixed = 'FIXED'
}

export type BirthdayTierBonusRulesRs = {
  __typename?: 'BirthdayTierBonusRulesRs';
  data?: Maybe<Array<Maybe<BirthdayTierBonusRule>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type BookmarksQueryCriteria = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  postGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Catalog = {
  __typename?: 'Catalog';
  categories?: Maybe<Array<Maybe<CatalogCategory>>>;
  countryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  estDeliveryTimeUnit?: Maybe<EstDeliveryTimeUnit>;
  estDeliveryTimeValue?: Maybe<Scalars['Int']['output']>;
  exts?: Maybe<Array<Maybe<CatalogExt>>>;
  guid?: Maybe<Scalars['String']['output']>;
  isNeedApproval?: Maybe<Scalars['Boolean']['output']>;
  minLevelToReach?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productDenomGuid?: Maybe<Scalars['String']['output']>;
  redeemCount?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CatalogStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
};

export type CatalogCategory = {
  __typename?: 'CatalogCategory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
};

export type CatalogCategoryCriteria = {
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: Scalars['String']['input'];
};

export type CatalogCategoryRs = {
  __typename?: 'CatalogCategoryRs';
  data?: Maybe<Array<Maybe<CatalogCategory>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type CatalogCriteria = {
  category?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  isNeedApproval?: InputMaybe<Scalars['String']['input']>;
  minLevelToReach?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  productDenomGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: CatalogStatus;
};

export type CatalogExt = {
  __typename?: 'CatalogExt';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByGuid?: Maybe<Scalars['String']['output']>;
  extType?: Maybe<Scalars['String']['output']>;
  extValue?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FetchFileResponse>;
  guid?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByGuid?: Maybe<Scalars['String']['output']>;
};

export type CatalogRs = {
  __typename?: 'CatalogRs';
  data?: Maybe<Array<Maybe<Catalog>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum CatalogStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ChangePassRq = {
  /**  ... new password to replace registered password */
  newPassword: Scalars['String']['input'];
  /**  ... old registered password */
  oldPassword: Scalars['String']['input'];
};

export type CheckoutRequest = {
  amount?: InputMaybe<Scalars['String']['input']>;
  ccy?: InputMaybe<Scalars['String']['input']>;
  channelCode?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  denomGuid?: InputMaybe<Scalars['String']['input']>;
  gameFieldJson?: InputMaybe<Scalars['JSON']['input']>;
  gameId?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  productGuid?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  txnAmount?: InputMaybe<Scalars['String']['input']>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
  webtopupRef?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutResponse = {
  __typename?: 'CheckoutResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type CmsBookmarks = {
  __typename?: 'CmsBookmarks';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  postGuid?: Maybe<Scalars['String']['output']>;
  /** Bookmarked Post. */
  posts?: Maybe<Array<Maybe<CmsPost>>>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userGuid?: Maybe<Scalars['String']['output']>;
};

export type CmsCommentReaction = {
  __typename?: 'CmsCommentReaction';
  commentGuid?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  lastCount?: Maybe<Scalars['String']['output']>;
  mutation?: Maybe<Scalars['String']['output']>;
  newCount?: Maybe<Scalars['Int']['output']>;
  postGuid?: Maybe<Scalars['String']['output']>;
  reactionType?: Maybe<Scalars['String']['output']>;
  userGuid?: Maybe<Scalars['String']['output']>;
};

export type CmsLockPost = {
  __typename?: 'CmsLockPost';
  guid?: Maybe<Scalars['String']['output']>;
  postGuid?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Long']['output']>;
  user?: Maybe<AppLoginSubject>;
  userGuid?: Maybe<Scalars['String']['output']>;
};

export type CmsLockPostQueryCriteria = {
  guid?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  postGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type CmsPost = {
  __typename?: 'CmsPost';
  author?: Maybe<CmsUser>;
  authorGuid?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  /** Bookmark status based on user guid in Authorization header */
  bookmarkStatus?: Maybe<CmsBookmarks>;
  /** Category terms of the post */
  categories?: Maybe<Array<Maybe<CmsPostTerm>>>;
  commentCount?: Maybe<Scalars['Int']['output']>;
  /** Open/Closed post comment status */
  commentStatus?: Maybe<Scalars['String']['output']>;
  /** Comments of the post */
  comments?: Maybe<Array<Maybe<CmsPostComment>>>;
  /** Video thumbnail/Live thumbnail */
  contentOption?: Maybe<ContentOption>;
  country?: Maybe<Country>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByGuid?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  /** Pin or un-pin a post */
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  lockPost?: Maybe<LockPost>;
  /** Content of the post */
  postBody?: Maybe<Scalars['String']['output']>;
  /** Ext of the post */
  postExt?: Maybe<Array<Maybe<CmsPostExt>>>;
  /** For SEO purposes. Max length: 160 */
  postMetaDescription?: Maybe<Scalars['String']['output']>;
  /** DRAFT/ON_REVIEW/PUBLISHED post status */
  postStatus?: Maybe<Scalars['String']['output']>;
  postTitle?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Reaction status of the post */
  reactionStatus?: Maybe<Array<Maybe<CmsReactionStatus>>>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** Tag terms of the post */
  tags?: Maybe<Array<Maybe<CmsPostTerm>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByGuid?: Maybe<Scalars['String']['output']>;
  urlKey?: Maybe<Scalars['String']['output']>;
  /** Video/Live content option source */
  videoSource?: Maybe<Scalars['String']['output']>;
  /** Settings for view count  */
  viewCount?: Maybe<Scalars['Boolean']['output']>;
  /** views of the post */
  views?: Maybe<CmsPostViewsRecord>;
};

export type CmsPostComment = {
  __typename?: 'CmsPostComment';
  author?: Maybe<CmsUser>;
  /** User browser information */
  commentAgent?: Maybe<Scalars['String']['output']>;
  commentAuthor?: Maybe<AppLoginSubject>;
  commentAuthorEmail: Scalars['String']['output'];
  commentAuthorIp: Scalars['String']['output'];
  commentAuthorName: Scalars['String']['output'];
  commentContent: Scalars['String']['output'];
  commentCount?: Maybe<CommentCount>;
  commentEmojiNo?: Maybe<Scalars['Int']['output']>;
  commentParentGuid?: Maybe<Scalars['String']['output']>;
  /** Possible value: APPROVED/UNAPPROVED */
  commentStatus: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByGuid: Scalars['String']['output'];
  guid: Scalars['String']['output'];
  postGuid?: Maybe<Scalars['String']['output']>;
  /** Reaction status of the comment */
  reactionStatus?: Maybe<Array<Maybe<CmsReactionStatus>>>;
  revision: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedByGuid: Scalars['String']['output'];
};

export type CmsPostCommentFilter = {
  /** User browser information */
  commentAgent?: InputMaybe<Scalars['String']['input']>;
  commentAuthorEmail?: InputMaybe<Scalars['String']['input']>;
  commentAuthorGuid?: InputMaybe<Scalars['String']['input']>;
  commentAuthorIp?: InputMaybe<Scalars['String']['input']>;
  commentAuthorName?: InputMaybe<Scalars['String']['input']>;
  commentContent?: InputMaybe<Scalars['String']['input']>;
  commentEmojiNo?: InputMaybe<Scalars['Int']['input']>;
  commentParentGuid?: InputMaybe<Scalars['String']['input']>;
  /** Possible value: APPROVED/UNAPPROVED */
  commentStatus?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdByGuid?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  postGuid?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalRecords?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedByGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CmsPostCommentResult = {
  __typename?: 'CmsPostCommentResult';
  data: Array<Maybe<CmsPostComment>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

/** CmsPost Connection */
export type CmsPostConnection = {
  __typename?: 'CmsPostConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<CmsPostEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** CmsPost Edge */
export type CmsPostEdge = {
  __typename?: 'CmsPostEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Field node */
  node?: Maybe<CmsPost>;
};

export type CmsPostExt = {
  __typename?: 'CmsPostExt';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByGuid?: Maybe<Scalars['String']['output']>;
  /** Possible value: CONTENT_IMAGE_POST/SQUARE_THUMBNAIL */
  extType?: Maybe<Scalars['String']['output']>;
  /** Guid value referencing to Amazon S3 image file */
  extValue?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FetchFileResponse>;
  guid?: Maybe<Scalars['String']['output']>;
  postGuid?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByGuid?: Maybe<Scalars['String']['output']>;
};

export type CmsPostExtQueryCriteria = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdByGuid?: InputMaybe<Scalars['String']['input']>;
  /** Possible value: CONTENT_IMAGE_POST/SQUARE_THUMBNAIL */
  extType?: InputMaybe<Scalars['String']['input']>;
  /** Guid value referencing to Amazon S3 image file */
  extValue?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  postGuid?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedByGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CmsPostFilter = {
  /** fill with end cursor id to get next data/page, cannot use this if already use 'before' filter */
  after?: InputMaybe<Scalars['String']['input']>;
  authorGuid?: InputMaybe<Scalars['String']['input']>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** fill with start cursor id to get prev data/page, cannot use this if already use 'after' filter */
  before?: InputMaybe<Scalars['String']['input']>;
  commentCount?: InputMaybe<Scalars['Int']['input']>;
  /** Open/Closed post comment status */
  commentStatus?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Country guid of the post */
  countryGuid?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdByGuid?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  /** Pin or un-pin a post */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: Scalars['Int']['input'];
  /** Content of the post */
  postBody?: InputMaybe<Scalars['String']['input']>;
  /** For SEO purposes. Max length: 160 */
  postMetaDescription?: InputMaybe<Scalars['String']['input']>;
  /** DRAFT/ON_REVIEW/PUBLISHED post status */
  postStatus?: InputMaybe<Scalars['String']['input']>;
  postTitle?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sortBy: CmsPostSortByEnum;
  sortDirection?: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  /** Search by termName: Name of the Category/Post tag */
  termNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search by termType, possible value: CATEGORY/POST_TAG */
  termType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedByGuid?: InputMaybe<Scalars['String']['input']>;
  /** The part of a static URL that describes the post */
  urlKey?: InputMaybe<Scalars['String']['input']>;
};

export type CmsPostFilterPublic = {
  /** fill with end cursor id to get next data/page, cannot use this if already use 'before' filter */
  after?: InputMaybe<Scalars['String']['input']>;
  authorGuid?: InputMaybe<Scalars['String']['input']>;
  /** fill with start cursor id to get prev data/page, cannot use this if already use 'after' filter */
  before?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  /** Pin or un-pin a post */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: Scalars['Int']['input'];
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sortBy: CmsPostPublicSortByEnum;
  sortDirection?: Scalars['String']['input'];
  /** Search by termName: Name of the Category/Post tag */
  termName?: InputMaybe<Scalars['String']['input']>;
  /** Search by termType, possible value: CATEGORY/POST_TAG */
  termType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** The part of a static URL that describes the post */
  urlKey?: InputMaybe<Scalars['String']['input']>;
};

export enum CmsPostPublicSortByEnum {
  PublishedAt = 'publishedAt'
}

export type CmsPostResult = {
  __typename?: 'CmsPostResult';
  data: Array<Maybe<CmsPost>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum CmsPostSortByEnum {
  ExpiredAt = 'expiredAt',
  PublishedAt = 'publishedAt',
  UpdatedAt = 'updatedAt'
}

export type CmsPostTerm = {
  __typename?: 'CmsPostTerm';
  createdAt: Scalars['DateTime']['output'];
  createdByGuid: Scalars['String']['output'];
  guid: Scalars['String']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastPostImageUrl?: Maybe<Scalars['String']['output']>;
  /** Cms Posts under selected Term */
  posts?: Maybe<Array<Maybe<CmsPost>>>;
  revision: Scalars['String']['output'];
  status: Scalars['String']['output'];
  termDescription?: Maybe<Scalars['String']['output']>;
  /** Name of the Category/Tag. Ex: Anime & Manga, Profile */
  termName: Scalars['String']['output'];
  termParentGuid?: Maybe<Scalars['String']['output']>;
  /** Possible value: CATEGORY/POST_TAG */
  termType: TermType;
  updatedAt: Scalars['DateTime']['output'];
  updatedByGuid: Scalars['String']['output'];
  urlKey?: Maybe<Scalars['String']['output']>;
};

export type CmsPostTermFilter = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdByGuid?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  termDescription?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Category/Tag. Ex: Anime & Manga, Profile */
  termName?: InputMaybe<Scalars['String']['input']>;
  termParentGuid?: InputMaybe<Scalars['String']['input']>;
  /** Possible value: CATEGORY/POST_TAG */
  termType?: InputMaybe<TermType>;
  totalRecords?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedByGuid?: InputMaybe<Scalars['String']['input']>;
  urlKey?: InputMaybe<Scalars['String']['input']>;
};

export type CmsPostTermRelationship = {
  __typename?: 'CmsPostTermRelationship';
  guid: Scalars['String']['output'];
  postGuid: Scalars['String']['output'];
  termGuid: Scalars['String']['output'];
  /** Category/Post tag ordering */
  termOrder: Scalars['Int']['output'];
};

export type CmsPostTermRelationshipQueryCriteria = {
  guid?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  postGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  termGuid?: InputMaybe<Scalars['String']['input']>;
  /** Category/Post tag ordering */
  termOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CmsPostTermResult = {
  __typename?: 'CmsPostTermResult';
  data: Array<Maybe<CmsPostTerm>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type CmsPostViews = {
  __typename?: 'CmsPostViews';
  createdAt?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  postGuid?: Maybe<Scalars['String']['output']>;
  userGuid?: Maybe<Scalars['String']['output']>;
};

export type CmsPostViewsCriteria = {
  guid?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  postGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CmsPostViewsRecord = {
  __typename?: 'CmsPostViewsRecord';
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CmsPostViewsResult = {
  __typename?: 'CmsPostViewsResult';
  data: Array<Maybe<CmsPostViews>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type CmsReactionCriteria = {
  commentGuid?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  isMutation?: InputMaybe<Scalars['Boolean']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  postGuid?: InputMaybe<Scalars['String']['input']>;
  /** Possible value: LIKE, HEART */
  reactionType?: InputMaybe<ReactionType>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CmsReactionResult = {
  __typename?: 'CmsReactionResult';
  data: Array<Maybe<CmsCommentReaction>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type CmsReactionStatus = {
  __typename?: 'CmsReactionStatus';
  /** Possible value: 1= LIKE/HEART, -1= UNLIKE/UNHEART, null */
  mutation?: Maybe<Scalars['Int']['output']>;
  /** Possible value: LIKE, HEART */
  reactionType?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CmsUser = {
  __typename?: 'CmsUser';
  authUserGuid?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<FetchFileResponse>;
  guid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByGuid?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type CmsUserFilter = {
  authUserGuid?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedByGuid?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type CommentCount = {
  __typename?: 'CommentCount';
  count: Scalars['Int']['output'];
};

export enum CommentStatus {
  Approved = 'APPROVED',
  Unapproved = 'UNAPPROVED'
}

export type Company = {
  __typename?: 'Company';
  /**  ... company code */
  code?: Maybe<Scalars['String']['output']>;
  /**  ... company country */
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**  ... user that create this company */
  createdBy?: Maybe<AppLoginSubject>;
  /**  ... company description */
  description?: Maybe<Scalars['String']['output']>;
  /**  ... company displayed name */
  displayName?: Maybe<Scalars['String']['output']>;
  /**  ... Company identifier */
  guid?: Maybe<Scalars['String']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  /**  ... company name */
  name?: Maybe<Scalars['String']['output']>;
  /**  ... data version */
  revision?: Maybe<Scalars['String']['output']>;
  /**  ... company status */
  status?: Maybe<Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**  ... last user that update this company */
  updatedBy?: Maybe<AppLoginSubject>;
};

export type CompanyFilter = {
  code?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isInternal?: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: Status;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyWithFilterRs = {
  __typename?: 'CompanyWithFilterRs';
  data?: Maybe<Array<Maybe<Company>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum ContentOption {
  LiveThumbnail = 'LIVE_THUMBNAIL',
  VideoThumbnail = 'VIDEO_THUMBNAIL'
}

export type ContractTemplate = {
  __typename?: 'ContractTemplate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<ContractTemplateDetail>>;
  guid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
};

export type ContractTemplateCriteria = {
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ... for filter by name ilike */
  name?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  productSelection?: InputMaybe<ProductSelectionEnum>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: Status;
};

export type ContractTemplateDetail = {
  __typename?: 'ContractTemplateDetail';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  paymentProvider?: Maybe<PaymentProvider>;
  product?: Maybe<ProductPage>;
  productDenom?: Maybe<ProductDenomination>;
  productSelection?: Maybe<ProductSelectionEnum>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
};

export type ContractTemplateDetailCriteria = {
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  paymentProviderGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  productDenomGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  productGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  productSelection?: InputMaybe<ProductSelectionEnum>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: Status;
};

export type ContractTemplateDetailRs = PageableRs & {
  __typename?: 'ContractTemplateDetailRs';
  data?: Maybe<Array<ContractTemplateDetail>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type ContractTemplateRs = PageableRs & {
  __typename?: 'ContractTemplateRs';
  data?: Maybe<Array<ContractTemplate>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  defaultLangCode?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  langCodes?: Maybe<Array<Maybe<LangCode>>>;
  name?: Maybe<Scalars['String']['output']>;
  phoneCodes?: Maybe<Array<Maybe<PhoneCode>>>;
  status?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CountryQueryCriteria = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultLangCode?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Array<Scalars['String']['input']>>;
  langCode?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  phoneCode?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountryResult = {
  __typename?: 'CountryResult';
  data: Array<Maybe<Country>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type CreateApiCredentialRoleRq = {
  apiCredentialGuid?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  roleGuid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApiCredentialRq = {
  accessKey?: InputMaybe<Scalars['String']['input']>;
  activeAt?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transactionalUserGuid?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApprovalRq = {
  approvalGroupGuid?: InputMaybe<Scalars['String']['input']>;
  /** ... required valid json string */
  data?: InputMaybe<Scalars['String']['input']>;
  entity: Scalars['String']['input'];
  entityGuid: Scalars['String']['input'];
  permission: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  sourcePlatform: Scalars['String']['input'];
  type: ApprovalTypeEnum;
  urlToCall: Scalars['String']['input'];
};

export type CreateAuditTrailRq = {
  action?: InputMaybe<Scalars['String']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  codeLine?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  function?: InputMaybe<Scalars['String']['input']>;
  isSystemGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  msSource: Scalars['String']['input'];
  sourceIp: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<AuditTagRq>>>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAuthSettingRq = {
  /**  ... Setting code (not editable) */
  code?: InputMaybe<Scalars['String']['input']>;
  /**  ... Setting name */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  ... Setting value */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAuthorHistoricalSlugRq = {
  slug: Scalars['String']['input'];
  userGuid: Scalars['String']['input'];
};

export type CreateBookmarkRq = {
  /** Post Guid that going to be saved. */
  postGuid?: InputMaybe<Scalars['String']['input']>;
  /** User Guid that saving the post. */
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCmsPostCommentRq = {
  commentContent: Scalars['String']['input'];
  commentParentGuid?: InputMaybe<Scalars['String']['input']>;
  postGuid: Scalars['String']['input'];
};

export type CreateCmsPostExtRq = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_by_guid?: InputMaybe<Scalars['String']['input']>;
  /** Possible value: CONTENT_IMAGE_POST/SQUARE_THUMBNAIL */
  ext_type: Scalars['String']['input'];
  /** Guid value referencing to Amazon S3 image file */
  ext_value: Scalars['String']['input'];
  post_guid: Scalars['String']['input'];
  status: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by_guid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCmsPostRq = {
  authorGuid: Scalars['String']['input'];
  authorName?: InputMaybe<Scalars['String']['input']>;
  commentCount?: InputMaybe<Scalars['Int']['input']>;
  /** Open/Closed post comment status */
  commentStatus: Scalars['String']['input'];
  /** Video thumbnail/Live thumbnail */
  contentOption?: InputMaybe<ContentOption>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Country guid of the post */
  countryGuid?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Pin or un-pin a post */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  paymentChannelGuid?: InputMaybe<Scalars['String']['input']>;
  /** Content of the post */
  postBody: Scalars['String']['input'];
  /** Terms-Category guid of the post */
  postCategoryGuid?: InputMaybe<Scalars['String']['input']>;
  /** For SEO purposes. Max length: 160 */
  postMetaDescription?: InputMaybe<Scalars['String']['input']>;
  /** DRAFT/ON_REVIEW/PUBLISHED post status */
  postStatus: Scalars['String']['input'];
  /** Terms-PostTag names of the post */
  postTagNames: Array<InputMaybe<Scalars['String']['input']>>;
  postTitle: Scalars['String']['input'];
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The part of a static URL that describes the post */
  urlKey: Scalars['String']['input'];
  /** Video/Live content option source */
  videoSource?: InputMaybe<Scalars['String']['input']>;
  /** Settings for view count  */
  viewCount?: Scalars['Boolean']['input'];
};

export type CreateCmsPostTermRelationshipRq = {
  postGuid: Scalars['String']['input'];
  termGuid?: InputMaybe<Scalars['String']['input']>;
  /** Category/Post tag ordering */
  termOrder: Scalars['Int']['input'];
};

export type CreateCmsPostTermRq = {
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  termDescription?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Category/Tag. Ex: Anime & Manga, Profile */
  termName: Scalars['String']['input'];
  termParentGuid?: InputMaybe<Scalars['String']['input']>;
  /** Possible value: CATEGORY/POST_TAG */
  termType: TermType;
  urlKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCmsReactionRq = {
  commentGuid?: InputMaybe<Scalars['String']['input']>;
  /** Possible value: true = LIKE/HEART , false = UNLIKE/UNHEART */
  isMutation: Scalars['Boolean']['input'];
  postGuid: Scalars['String']['input'];
  /** Possible value: LIKE, HEART */
  reactionType: ReactionType;
  userGuid: Scalars['String']['input'];
};

export type CreateCmsUserRq = {
  authUserGuid?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyRq = {
  /**  ... company code */
  code?: InputMaybe<Scalars['String']['input']>;
  /**  ... company country */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /**  ... company description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**  ... company displayed name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /**  ... company name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConsentToAgreeRq = {
  historyAgreementGuid?: InputMaybe<Scalars['String']['input']>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractTemplateRq = {
  contractTemplateDetailGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CreateHistoryAgreementRq = {
  agreementCode?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Status>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMemberRq = {
  birthdayAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredLangCode?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMerchantContractRq = {
  contractTemplateGuid: Scalars['String']['input'];
  merchantGuid: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateMerchantPaymentDenomRq = {
  amount?: InputMaybe<Scalars['Double']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  paymentChannelGuid?: InputMaybe<Scalars['String']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMerchantPaymentProviderRq = {
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  providerGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMerchantRq = {
  companyGuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMessageTemplateRq = {
  /**  ... message id */
  messageId: Scalars['String']['input'];
  /**  ... base64 encoded html or message template */
  value: Scalars['String']['input'];
};

export type CreateNotificationAlertRq = {
  description: Scalars['String']['input'];
  receiverCompanyGuid?: InputMaybe<Scalars['String']['input']>;
  receiverGuid?: InputMaybe<Scalars['String']['input']>;
  receiverMerchantGuid?: InputMaybe<Scalars['String']['input']>;
  receiverPermissionCode?: InputMaybe<Scalars['String']['input']>;
  status: NotifAlertStatusEnum;
  targetGuid: Scalars['String']['input'];
  targetType: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: AlertTypeEnum;
};

export type CreatePaymentChannelDenomRq = {
  amount?: InputMaybe<Scalars['Double']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['Long']['input']>;
  payamentChannelGuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentChannelGuidelineRq = {
  paymentChannelGuid: Scalars['String']['input'];
  postGuid: Scalars['String']['input'];
};

export type CreatePaymentChannelRq = {
  category?: InputMaybe<Scalars['String']['input']>;
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  charge?: InputMaybe<Scalars['Float']['input']>;
  chargeType?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  companyCredentialGuid: Scalars['String']['input'];
  contractorCompanyGuid: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  credentialGuid?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  isWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmount?: InputMaybe<Scalars['Long']['input']>;
  metaFieldJson?: InputMaybe<Array<InputMaybe<PaymentChannelMetaField>>>;
  minAmount?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameter?: InputMaybe<Scalars['String']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  providerCompanyGuid?: InputMaybe<Scalars['String']['input']>;
  providerPriority?: InputMaybe<Scalars['String']['input']>;
  rateTemplateGuid?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  requiredFieldJson?: InputMaybe<Array<InputMaybe<RequiredField>>>;
  route?: InputMaybe<Scalars['String']['input']>;
  serviceCompanyGuid: Scalars['String']['input'];
  vatPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePaymentProviderRq = {
  category?: InputMaybe<Scalars['String']['input']>;
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<Scalars['Long']['input']>;
  minAmount?: InputMaybe<Scalars['Long']['input']>;
  providerExternalName?: InputMaybe<Scalars['String']['input']>;
  providerInternalName?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePermRq = {
  /**  ... permission parent identifier */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /**  ... permission code */
  permCode: Scalars['String']['input'];
  /**  ... permission description */
  permDescription?: InputMaybe<Scalars['String']['input']>;
  /**  ... permission module */
  permModule: Scalars['String']['input'];
  /**  ... permission name */
  permName: Scalars['String']['input'];
  /**  ... permission scope */
  permScope: Scalars['String']['input'];
  /**  ... permission type eX: WRITE, READ, etc */
  permType: Scalars['String']['input'];
  /**  ... related micro frontend */
  relatedMf?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePostHistoricalSlugRq = {
  postGuid: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreateProductDenominationRq = {
  adjustableSellingPrice?: InputMaybe<Scalars['Boolean']['input']>;
  imageGuid?: InputMaybe<Scalars['String']['input']>;
  isDirectVoucher?: InputMaybe<Scalars['Boolean']['input']>;
  isVoucherApi?: InputMaybe<Scalars['Boolean']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerProductId?: InputMaybe<Scalars['String']['input']>;
  productPageGuid?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  voucherGroupGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductPageRq = {
  advanceSearch?: InputMaybe<Scalars['String']['input']>;
  category: ProductPageCategory;
  communityLink?: InputMaybe<Scalars['String']['input']>;
  companyGuid?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  credentialGuid?: InputMaybe<Scalars['String']['input']>;
  downloadLink?: InputMaybe<Scalars['String']['input']>;
  gameCenterImage?: InputMaybe<Scalars['String']['input']>;
  gameChildCode?: InputMaybe<Scalars['String']['input']>;
  gameParentCode?: InputMaybe<Scalars['String']['input']>;
  huaweiDownloadLink?: InputMaybe<Scalars['String']['input']>;
  iconGuid?: InputMaybe<Scalars['String']['input']>;
  influencerLink?: InputMaybe<Scalars['String']['input']>;
  iosDownloadLink?: InputMaybe<Scalars['String']['input']>;
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isShowOnLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaFieldJson?: InputMaybe<Array<InputMaybe<ProductPageMetaField>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  officialSiteLink?: InputMaybe<Scalars['String']['input']>;
  providerCompanyGuid?: InputMaybe<Scalars['String']['input']>;
  requiredFieldJson?: InputMaybe<Array<InputMaybe<RequiredField>>>;
  route?: InputMaybe<Scalars['String']['input']>;
  schemaMarkUp?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topUpGuideLink?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductPriceListRq = {
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  contractTemplateGuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventCode?: InputMaybe<Scalars['String']['input']>;
  magnifyValue?: InputMaybe<Scalars['Int']['input']>;
  paymentProviderCode?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priority: Scalars['Int']['input'];
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
  productPageGuid?: InputMaybe<Scalars['String']['input']>;
  rateTemplateGuid: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type: PriceListType;
};

export type CreateRateCardTemplateDetailsRq = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  magnifyValue: Scalars['Int']['input'];
  minimumRate: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  paymentProviderCode?: InputMaybe<Scalars['String']['input']>;
  priority: Scalars['Int']['input'];
  rate: Scalars['Float']['input'];
  rateLogic: RateLogic;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateRateCardTemplateRq = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateRoleRq = {
  /**  ... role code */
  code: Scalars['String']['input'];
  /**  ... role description */
  description?: InputMaybe<Scalars['String']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /**  ... role name */
  name: Scalars['String']['input'];
};

export type CreateSuspiciousTagRq = {
  actionCode?: InputMaybe<Scalars['String']['input']>;
  actionJson?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  intervalParam?: InputMaybe<Scalars['String']['input']>;
  targetCode?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTemplateDetailRq = {
  paymentProviderGuid?: InputMaybe<Scalars['String']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
  productGuid?: InputMaybe<Scalars['String']['input']>;
  productSelection?: ProductSelectionEnum;
};

export type CreateUserRq = {
  /**  ... email to register user [Optional] */
  email?: InputMaybe<Scalars['String']['input']>;
  /**  ... user gender [MALE/FEMALE] */
  gender: Gender;
  /**  ... mobile nunber to register user [Optional] */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  /**  ... user full name */
  name: Scalars['String']['input'];
};

export type CreateVacancyRq = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  requirement?: InputMaybe<Scalars['String']['input']>;
  responsibility?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVacancySettingsRq = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateVoucherGroupAutoGenRq = {
  /**  amount of voucher that will auto generate  */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /**  Timeout generation Input number in second  */
  generationTimeout?: InputMaybe<Scalars['Int']['input']>;
  /**  Minimum stock that will auto generate after reach  */
  minThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**  GUID of voucher group  */
  voucherGroupGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVoucherGroupRq = {
  /**  Currency  */
  currency?: InputMaybe<Scalars['String']['input']>;
  /**  to magnify value above before display to user  */
  magnifyValue?: InputMaybe<Scalars['Int']['input']>;
  /**  Name of voucher group  */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  Voucher that have pin, this one to set the pattern  */
  pinPattern: Scalars['JSON']['input'];
  /**  Voucher that have serial, this one to set the pattern  */
  serialPattern: Scalars['JSON']['input'];
  /**  Type of voucher group  */
  type?: InputMaybe<VoucherGroupType>;
  /**  Voucher price to check when redeem */
  value?: InputMaybe<Scalars['Int']['input']>;
  /**  Code for API type voucher only  */
  voucherApiCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVoucherRq = {
  /**  voucher activation pin  */
  activationPin?: InputMaybe<Scalars['String']['input']>;
  /**  voucher name  */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  start date for this voucher able to redeemed  */
  redeemableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /**  end date for this voucher able to redeemed  */
  redeemableTo?: InputMaybe<Scalars['DateTime']['input']>;
  /**  voucher serial number  */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /**  voucher softpin  */
  softpin?: InputMaybe<Scalars['String']['input']>;
  /**  voucher url key  */
  urlKey?: InputMaybe<Scalars['String']['input']>;
  /**  voucher group associated with this voucher  */
  voucherGroupGuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWebConfigRq = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  jsonValue?: InputMaybe<Scalars['String']['input']>;
  numberValue?: InputMaybe<Scalars['Int']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Credential = {
  __typename?: 'Credential';
  code?: Maybe<Scalars['String']['output']>;
  companyGuid?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CredentialStatus>;
  type?: Maybe<CredentialType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type CredentialDetail = {
  __typename?: 'CredentialDetail';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CredentialType>;
  value?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type CredentialFilter = {
  code?: InputMaybe<Scalars['String']['input']>;
  companyGuid?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  isDecrypt?: Scalars['Boolean']['input'];
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: CredentialStatus;
  type?: InputMaybe<CredentialType>;
};

export type CredentialRs = {
  __typename?: 'CredentialRs';
  data?: Maybe<Array<Maybe<Credential>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum CredentialStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type CredentialTrail = {
  __typename?: 'CredentialTrail';
  code?: Maybe<Scalars['String']['output']>;
  companyGuid?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<Maybe<CredentialDetail>>>;
  guid?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CredentialStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type CredentialTrailRs = {
  __typename?: 'CredentialTrailRs';
  data?: Maybe<Array<Maybe<CredentialTrail>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum CredentialType {
  Secret = 'SECRET',
  Variable = 'VARIABLE'
}

export type Currency = {
  __typename?: 'Currency';
  code?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  magnifyValue?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CurrencyQueryCriteria = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  guid?: InputMaybe<Array<Scalars['String']['input']>>;
  magnifyValues?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CurrencyResult = {
  __typename?: 'CurrencyResult';
  data: Array<Maybe<Currency>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type DeliveryRequest = {
  ccy?: InputMaybe<Scalars['String']['input']>;
  channelCode?: InputMaybe<Scalars['String']['input']>;
  denomGuid?: InputMaybe<Scalars['String']['input']>;
  flowId?: InputMaybe<Scalars['String']['input']>;
  gameFieldJson?: InputMaybe<Scalars['JSON']['input']>;
  gameId?: InputMaybe<Scalars['String']['input']>;
  merchantCode?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  webtopupRef?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryResponse = {
  __typename?: 'DeliveryResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type DetachPermRq = {
  /**  permission identifier */
  permsGuid: Array<InputMaybe<Scalars['String']['input']>>;
  /**  role identifier */
  roleGuid: Scalars['String']['input'];
};

export type EmailMessageTemplate = {
  __typename?: 'EmailMessageTemplate';
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type EmailMessageTemplatePageableResult = {
  __typename?: 'EmailMessageTemplatePageableResult';
  data: Array<Maybe<EmailMessageTemplate>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type EmailMsgTemplateCriteria = {
  /**  ... message template identifier */
  guid?: InputMaybe<Scalars['String']['input']>;
  /**  ... message id */
  messageId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu = 'THROTTLED_CPU',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown = 'UNKNOWN'
}

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NotFound = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown = 'UNKNOWN'
}

export enum EstDeliveryTimeUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Workday = 'WORKDAY'
}

export enum EvaluationUnitEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

export enum EventType {
  Created = 'CREATED',
  Update = 'UPDATE'
}

export type FetchFileResponse = {
  __typename?: 'FetchFileResponse';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userGuid?: Maybe<Scalars['String']['output']>;
};

export type File = {
  __typename?: 'File';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userGuid?: Maybe<Scalars['String']['output']>;
};

export type FileUploadResponse = {
  __typename?: 'FileUploadResponse';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userGuid?: Maybe<Scalars['String']['output']>;
};

export type FirebaseIdTokenRes = {
  __typename?: 'FirebaseIdTokenRes';
  expiresIn?: Maybe<Scalars['String']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  isNewUser?: Maybe<Scalars['Boolean']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type ForgotPassOtpRq = {
  /**  ... email attached to user */
  email?: InputMaybe<Scalars['String']['input']>;
  /**  ... mobile number attached to user */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  /**  ... source platform where user registered */
  sourcePlatform: SourcePlatform;
};

export type ForgotPassRq = {
  /**  ... new user password to replace old password */
  newPassword: Scalars['String']['input'];
  /**  ... email or mobile nummber attached to user */
  principalId: Scalars['String']['input'];
  /**  ... source platform where user registered */
  sourcePlatform: SourcePlatform;
  /**  ... verification code requested before restet password */
  verifCode: Scalars['String']['input'];
};

export type GameRequiredField = {
  __typename?: 'GameRequiredField';
  dependant?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Option>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GameRequiredFieldInput = {
  serverId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type GameTrail = {
  __typename?: 'GameTrail';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  gameId?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  requestData?: Maybe<Scalars['JSON']['output']>;
  requestPlatform?: Maybe<Scalars['String']['output']>;
  responseData?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  txnRef?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GameTransactionCreateRequest = {
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
  productGuid?: InputMaybe<Scalars['String']['input']>;
  requestPlatform?: InputMaybe<Scalars['String']['input']>;
  sourceIp?: InputMaybe<Scalars['String']['input']>;
  transactionRef?: InputMaybe<Scalars['String']['input']>;
  txnCountryCode?: InputMaybe<Scalars['String']['input']>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type GameTransactionQueryCriteria = {
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  gameRef?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
  productGuid?: InputMaybe<Scalars['String']['input']>;
  requestPlatform?: InputMaybe<Scalars['String']['input']>;
  sourceIp?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transactionRef?: InputMaybe<Scalars['String']['input']>;
  txnCountryCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type GameTransactionUpdateRequest = {
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
  productGuid?: InputMaybe<Scalars['String']['input']>;
  requestPlatform?: InputMaybe<Scalars['String']['input']>;
  sourceIp?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  txnCountryCode?: InputMaybe<Scalars['String']['input']>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type GameTransactions = {
  __typename?: 'GameTransactions';
  ccyCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  gameRef?: Maybe<Scalars['String']['output']>;
  gameTrail?: Maybe<GameTrail>;
  guid?: Maybe<Scalars['String']['output']>;
  merchantGuid?: Maybe<Scalars['String']['output']>;
  productDenomGuid?: Maybe<Scalars['String']['output']>;
  productGuid?: Maybe<Scalars['String']['output']>;
  requestPlatform?: Maybe<Scalars['String']['output']>;
  sourceIp?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionRef?: Maybe<Scalars['String']['output']>;
  txnCountryCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userGuid?: Maybe<Scalars['String']['output']>;
};

export type GatewayCreateOrderRq = {
  /** Voucher Code on our side */
  denominationCode?: InputMaybe<Scalars['String']['input']>;
  /** Transaction Id for this voucher transaction */
  orderNo: Scalars['String']['input'];
  /** Product Id on 3rd party side */
  partnerProductId?: InputMaybe<Scalars['String']['input']>;
  /** Voucher API Code from Voucher Group */
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GenerateVoucherRq = {
  expiredDate?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  voucherGroupGuid?: InputMaybe<Scalars['String']['input']>;
};

export type HistoryAgreement = {
  __typename?: 'HistoryAgreement';
  agreementCode?: Maybe<Scalars['String']['output']>;
  agreementGuid?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type HistoryAgreementQueryCriteria = {
  agreementCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  guid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type InquiryRequest = {
  amount?: InputMaybe<Scalars['String']['input']>;
  ccy?: InputMaybe<Scalars['String']['input']>;
  channelCode?: InputMaybe<Scalars['String']['input']>;
  gameFieldJson?: InputMaybe<Scalars['JSON']['input']>;
  gameId?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type InquiryResponse = {
  __typename?: 'InquiryResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export enum InternalStatus {
  Completed = 'COMPLETED',
  Fail = 'FAIL',
  PendingApproval = 'PENDING_APPROVAL',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  Todo = 'TODO'
}

export type LangCode = {
  __typename?: 'LangCode';
  code?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type LockPost = {
  __typename?: 'LockPost';
  guid?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<AppLoginSubject>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  /**  ... simple access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  /**  ... refresh token can use to request access token */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /**  ... suggested action */
  suggestedAction?: Maybe<SuggestedAction>;
  /**  ... user detail */
  user?: Maybe<UserLogin>;
};

export type LoginRq = {
  /**  ... email registered to user */
  email?: InputMaybe<Scalars['String']['input']>;
  /**  ... mobile number registered to user */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  /**  ... user password */
  password: Scalars['String']['input'];
  /**  ... source platform where user registered */
  sourcePlatform: SourcePlatform;
};

export type Member = {
  __typename?: 'Member';
  authUser?: Maybe<AppLoginSubject>;
  birthdayAt?: Maybe<Scalars['DateTime']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  memberBan?: Maybe<MemberBan>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredLangCode?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  tiers?: Maybe<Array<Maybe<Tier>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MemberBan = {
  __typename?: 'MemberBan';
  approvalData?: Maybe<Scalars['JSON']['output']>;
  approvalGuid?: Maybe<Scalars['String']['output']>;
  approvalStatus?: Maybe<Scalars['String']['output']>;
  approvalType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  memberGuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MemberBanType>;
};

export enum MemberBanType {
  Ban = 'BAN',
  Unban = 'UNBAN'
}

export type MemberCriteria = {
  banType?: InputMaybe<MemberBanType>;
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  parentMemberGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
  referralCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  summaryCountryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MemberPageableResponse = {
  __typename?: 'MemberPageableResponse';
  data?: Maybe<Array<Maybe<Member>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type MemberPoint = {
  __typename?: 'MemberPoint';
  amountSpent?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  memberGuid?: Maybe<Scalars['String']['output']>;
  pointRewarded?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  transactionRewardRef?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MemberPointTypeEnum>;
};

export type MemberPointCriteria = {
  amountSpent?: InputMaybe<Scalars['Int']['input']>;
  countryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  memberGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  pointRewarded?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  transactionRewardRefs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MemberPointMutation = {
  __typename?: 'MemberPointMutation';
  countryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  memberGuid?: Maybe<Scalars['String']['output']>;
  pointAdd?: Maybe<Scalars['Float']['output']>;
  pointSubstract?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  transactionSpentRef?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MemberPointMutationTypeEnum>;
};

export type MemberPointMutationCriteria = {
  countryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  memberGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  pointAdd?: InputMaybe<Scalars['Int']['input']>;
  pointSubstract?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  transactionDate?: InputMaybe<Scalars['DateTime']['input']>;
  transactionSpentRefs?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<MemberPointMutationTypeEnum>;
};

export enum MemberPointMutationTypeEnum {
  Adjustment = 'ADJUSTMENT',
  Bonus = 'BONUS',
  Rewarded = 'REWARDED',
  Spent = 'SPENT'
}

export type MemberPointMutationsRs = {
  __typename?: 'MemberPointMutationsRs';
  data?: Maybe<Array<Maybe<MemberPointMutation>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type MemberPointSummary = {
  __typename?: 'MemberPointSummary';
  countryId?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  evaluationDate?: Maybe<Scalars['DateTime']['output']>;
  evaluationPoint?: Maybe<Scalars['Float']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  memberGuid?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MemberPointSummaryCriteria = {
  countryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  memberGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
};

export type MemberPointSummaryRs = {
  __typename?: 'MemberPointSummaryRs';
  data?: Maybe<Array<Maybe<MemberPointSummary>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum MemberPointTypeEnum {
  Adjustment = 'ADJUSTMENT',
  Rewarded = 'REWARDED'
}

export type MemberPointsRs = {
  __typename?: 'MemberPointsRs';
  data?: Maybe<Array<Maybe<MemberPoint>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type Merchant = {
  __typename?: 'Merchant';
  company?: Maybe<Company>;
  createBy?: Maybe<AppLoginSubject>;
  createdAt?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  logoGuid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Status>;
  transactionalUser?: Maybe<AppLoginSubject>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<AppLoginSubject>;
};

export type MerchantContract = {
  __typename?: 'MerchantContract';
  contractTemplate?: Maybe<ContractTemplate>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  merchant?: Maybe<Merchant>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
};

export type MerchantContractCriteria = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  merchantGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: Status;
};

export type MerchantContractRs = PageableRs & {
  __typename?: 'MerchantContractRs';
  data?: Maybe<Array<Maybe<MerchantContract>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type MerchantFilter = {
  companyGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: Status;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantFilterRs = {
  __typename?: 'MerchantFilterRs';
  data?: Maybe<Array<Maybe<Merchant>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type MerchantPaymentDenomination = {
  __typename?: 'MerchantPaymentDenomination';
  amount?: Maybe<Scalars['Double']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  merchantGuid?: Maybe<Scalars['String']['output']>;
  paymentChannelGuid?: Maybe<Scalars['String']['output']>;
  productDenomGuid?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MerchantPaymentProvider = {
  __typename?: 'MerchantPaymentProvider';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  merchantGuid?: Maybe<Scalars['String']['output']>;
  providerGuid?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Message = {
  __typename?: 'Message';
  message?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create Author Historical Slug if user already exists */
  CmsMsCreateAuthorHistoricalSlug?: Maybe<AuthorHistoricalSlug>;
  approvalMsApproveOrDeclineRequest?: Maybe<Scalars['String']['output']>;
  approvalMsCreateApprovalRequest?: Maybe<Array<Maybe<Approval>>>;
  /** used by other ms to send their data changes audit */
  auditMsCreateAuditTrail?: Maybe<AuditTrail>;
  /** create supicious tag configuration */
  auditMsCreateSuspiciousTag?: Maybe<SuspiciousTag>;
  /** update supicious tag configuration */
  auditMsDeleteSuspiciousTag?: Maybe<SuspiciousTag>;
  /** update supicious tag configuration */
  auditMsUpdateSuspiciousTag?: Maybe<SuspiciousTag>;
  /** add permission to role */
  authMsAttachPermToRole?: Maybe<Scalars['String']['output']>;
  /**
   * add role to user.
   * expiredDuration (number of days) is use to calculated expired date (current date + expiredDuration)
   */
  authMsAttachRolesToUsers?: Maybe<Scalars['String']['output']>;
  /** This query allow user to change their password, need Authorization Header */
  authMsChangePassword?: Maybe<Scalars['String']['output']>;
  authMsCreateApiCredential?: Maybe<ApiCredential>;
  /** create auth ms settings */
  authMsCreateAuthSettings?: Maybe<AuthSettings>;
  /** create new Company */
  authMsCreateCompany?: Maybe<Company>;
  /** create new Merchant */
  authMsCreateMerchant?: Maybe<Merchant>;
  /** create new permission */
  authMsCreatePermission?: Maybe<AppPermDfn>;
  /** create new role */
  authMsCreateRole?: Maybe<AppLoginRole>;
  /** This query allow you to create super admin user. Cant create super admin if super admin already exists */
  authMsCreateSuperAdmin?: Maybe<Scalars['String']['output']>;
  /** create user by admin, need authorization and project header */
  authMsCreateUserProfile?: Maybe<UserByAdmin>;
  authMsDeleteApiCredential?: Maybe<ApiCredential>;
  /** delete existing auth ms settings */
  authMsDeleteAuthSettings?: Maybe<AuthSettings>;
  /** delete existing company */
  authMsDeleteCompany?: Maybe<Company>;
  /** delete existing Merchant */
  authMsDeleteMerchant?: Maybe<Merchant>;
  /** delete existiing permission */
  authMsDeletePermission?: Maybe<Scalars['String']['output']>;
  /** delete existing role */
  authMsDeleteRole?: Maybe<AppLoginRole>;
  /** revoke permission to role */
  authMsDetachPermToRole?: Maybe<Scalars['String']['output']>;
  /** extend role to user linkage expired duration by days. */
  authMsExtendsRolesToUsersExpiredDate?: Maybe<Scalars['String']['output']>;
  /** This query allow user to reset their password */
  authMsForgotPassword?: Maybe<Scalars['String']['output']>;
  /** This query allow user to request reset password verification code */
  authMsForgotPasswordOtp?: Maybe<Scalars['String']['output']>;
  /** link company to merchants */
  authMsLinkCompanyToMerchants?: Maybe<Scalars['String']['output']>;
  /** link company to user */
  authMsLinkCompanyToUsers?: Maybe<Scalars['String']['output']>;
  /** link merchants to users */
  authMsLinkMerchantsToUsers?: Maybe<Scalars['String']['output']>;
  /** This query allow user to login */
  authMsLogin?: Maybe<LoginResponse>;
  /** This query allow user to refresh their access token */
  authMsRefreshAccessToken?: Maybe<Token>;
  /** This query allow user to do self registration */
  authMsRegister?: Maybe<AppLoginSubject>;
  /** This query use to resend email verification code */
  authMsResendEmailVerif?: Maybe<Scalars['String']['output']>;
  /** This query use to resend Mobile/OTP verification code */
  authMsResendMobileVerif?: Maybe<Scalars['String']['output']>;
  /** revole roles in from user */
  authMsRevokeRolesInUsers?: Maybe<Scalars['String']['output']>;
  /** This query allow user to validate firebase id token and login */
  authMsSocialLogin?: Maybe<LoginResponse>;
  /** temporary deactive user */
  authMsTemporaryUserDeactivation?: Maybe<Scalars['String']['output']>;
  /** unlink company to user */
  authMsUnLinkCompanyFromUsers?: Maybe<Scalars['String']['output']>;
  /** unlink company from merchants */
  authMsUnlinkCompanyFromMerchants?: Maybe<Scalars['String']['output']>;
  /** unlink merchnats from users */
  authMsUnlinkMerchantsFromUsers?: Maybe<Scalars['String']['output']>;
  authMsUpdateApiCredential?: Maybe<ApiCredential>;
  /** update existing auth ms settings */
  authMsUpdateAuthSettings?: Maybe<AuthSettings>;
  /** Update existion company */
  authMsUpdateCompany?: Maybe<Company>;
  /** update existing Merchant */
  authMsUpdateMerchant?: Maybe<Merchant>;
  /** update existing permission */
  authMsUpdatePermission?: Maybe<AppPermDfn>;
  /** update user principal by admin */
  authMsUpdatePrincipalForAdmin?: Maybe<AppLoginSubject>;
  /** update existing role */
  authMsUpdateRole?: Maybe<AppLoginRole>;
  /** update user by admin */
  authMsUpdateUserForAdmin?: Maybe<AppLoginSubject>;
  /** update principal id by user owner */
  authMsUpdateUserPrincipalByOwner?: Maybe<AppLoginSubject>;
  /** request otp for update principal by owned user */
  authMsUpdateUserPrincipalOtp?: Maybe<Scalars['String']['output']>;
  /** update user profile by user it self, need authorization header */
  authMsUpdateUserProfile?: Maybe<AppLoginSubject>;
  /** This query allow user to do user confirmation after registration */
  authMsUserConfirm?: Maybe<Scalars['String']['output']>;
  cmsMsAssignTermToPost?: Maybe<CmsPostTermRelationship>;
  cmsMsCreateBookmark?: Maybe<CmsBookmarks>;
  cmsMsCreateComment?: Maybe<CmsPostComment>;
  cmsMsCreatePost?: Maybe<CmsPost>;
  cmsMsCreatePostExts?: Maybe<CmsPostExt>;
  cmsMsCreatePostHistoricalSlug?: Maybe<PostHistoricalSlug>;
  cmsMsCreatePostTerm?: Maybe<CmsPostTerm>;
  /** This query is used to insert post views, Authorization header [userGuid] is optional */
  cmsMsCreatePostViews?: Maybe<CmsPostViews>;
  cmsMsCreateReaction?: Maybe<CmsCommentReaction>;
  cmsMsCreateUser?: Maybe<CmsUser>;
  cmsMsDeleteBookmark?: Maybe<CmsBookmarks>;
  cmsMsDeleteComment?: Maybe<CmsPostComment>;
  cmsMsDeletePost?: Maybe<CmsPost>;
  cmsMsDeletePostExts?: Maybe<CmsPostExt>;
  cmsMsDeletePostTerm?: Maybe<Array<Maybe<CmsPostTerm>>>;
  cmsMsDeleteUser?: Maybe<Scalars['String']['output']>;
  /** This query is used to update the heartbeat timestamps for edited posts if exists for the given postGuid otherwise create a new entry, need Authorization Header */
  cmsMsLockingPost?: Maybe<IsSuccess>;
  cmsMsRemoveTermFromPost?: Maybe<Scalars['String']['output']>;
  cmsMsUpdateBookmark?: Maybe<CmsBookmarks>;
  cmsMsUpdatePost?: Maybe<CmsPost>;
  cmsMsUpdatePostExts?: Maybe<CmsPostExt>;
  cmsMsUpdatePostTerm?: Maybe<CmsPostTerm>;
  cmsMsUpdateUser?: Maybe<CmsUser>;
  consentMsConsentToAgree?: Maybe<UserConsent>;
  consentMsCreateHistoryAgreement?: Maybe<HistoryAgreement>;
  consentMsUpdateHistoryAgreement?: Maybe<HistoryAgreement>;
  deletePaymentProviderExt?: Maybe<Scalars['String']['output']>;
  /**     remove this when there is field under mutation */
  emptyField?: Maybe<Scalars['String']['output']>;
  fileMgmtSysMsFileAccessControl?: Maybe<File>;
  fileMgmtSysMsFileDeletion?: Maybe<IsSuccess>;
  fileMgmtSysMsFileDownload?: Maybe<File>;
  fileMgmtSysMsFileNotification?: Maybe<File>;
  fileMgmtSysMsFileSharing?: Maybe<File>;
  fileMgmtSysMsFileStreaming?: Maybe<File>;
  fileMgmtSysMsFileUpload?: Maybe<FileUploadResponse>;
  fileMgmtSysMsFileVersioning?: Maybe<File>;
  ggwMsCheckout?: Maybe<CheckoutResponse>;
  ggwMsCreateGameTransaction?: Maybe<GameTransactions>;
  ggwMsDeleteGameTransaction?: Maybe<GameTransactions>;
  ggwMsDelivery?: Maybe<DeliveryResponse>;
  ggwMsInquiry?: Maybe<InquiryResponse>;
  ggwMsUpdateGameTransaction?: Maybe<GameTransactions>;
  /**
   * This mutation is replaced by REST endpoint due to file upload issue on graphql
   * @deprecated No longer supported
   */
  humanResourcesMsApply?: Maybe<VacancyApplication>;
  humanResourcesMsCreateVacancy?: Maybe<Vacancy>;
  humanResourcesMsCreateVacancySettings?: Maybe<VacancySettings>;
  humanResourcesMsDeleteVacancy?: Maybe<Vacancy>;
  humanResourcesMsDeleteVacancySettings?: Maybe<VacancySettings>;
  humanResourcesMsUpdateVacancy?: Maybe<Vacancy>;
  humanResourcesMsUpdateVacancySettings?: Maybe<VacancySettings>;
  membershipMsAssignTierToMember?: Maybe<Scalars['String']['output']>;
  membershipMsBanUser?: Maybe<Scalars['String']['output']>;
  membershipMsCreateBirthdayTierBonusRule?: Maybe<BirthdayTierBonusRule>;
  membershipMsCreateCatalog?: Maybe<Catalog>;
  membershipMsCreateCatalogCategory?: Maybe<CatalogCategory>;
  membershipMsCreateMemberPoint?: Maybe<MemberPoint>;
  membershipMsCreateMemberPointMutation?: Maybe<MemberPointMutation>;
  membershipMsCreateRedeemTransaction?: Maybe<RedeemTransaction>;
  membershipMsCreateTier?: Maybe<Tier>;
  membershipMsCreateTierBonusRule?: Maybe<TierBonusRule>;
  membershipMsDeleteBirthdayTierBonusRule?: Maybe<Scalars['String']['output']>;
  membershipMsDeleteCatalog?: Maybe<Scalars['String']['output']>;
  membershipMsDeleteCatalogCategory?: Maybe<Scalars['String']['output']>;
  membershipMsDeleteCatalogExt?: Maybe<Scalars['String']['output']>;
  membershipMsDeleteTier?: Maybe<Scalars['String']['output']>;
  membershipMsDeleteTierBonusRule?: Maybe<Scalars['String']['output']>;
  membershipMsDeleteTierExt?: Maybe<Scalars['String']['output']>;
  membershipMsUpdateBirthdayTierBonusRule?: Maybe<BirthdayTierBonusRule>;
  membershipMsUpdateCatalog?: Maybe<Catalog>;
  membershipMsUpdateCatalogCategory?: Maybe<CatalogCategory>;
  membershipMsUpdateRedeemTransaction?: Maybe<RedeemTransaction>;
  membershipMsUpdateTier?: Maybe<Tier>;
  membershipMsUpdateTierBonusRule?: Maybe<TierBonusRule>;
  /** create new message template */
  notificationMsCreateEmailMessageTemplate?: Maybe<EmailMessageTemplate>;
  notificationMsCreateNotificationAlert?: Maybe<NotificationAlert>;
  notificationMsCreateUserFcm?: Maybe<UserFcm>;
  /** update existing message template */
  notificationMsUpdateEmailMessageTemplate?: Maybe<EmailMessageTemplate>;
  notificationMsUpdateReadStatus?: Maybe<NotificationAlert>;
  productMsCreateContractTemplate?: Maybe<ContractTemplate>;
  productMsCreateContractTemplateDetail?: Maybe<ContractTemplateDetail>;
  productMsCreateMerchantContract?: Maybe<MerchantContract>;
  productMsCreateMerchantPaymentDenomination?: Maybe<MerchantPaymentDenomination>;
  productMsCreateMerchantPaymentProvider?: Maybe<MerchantPaymentProvider>;
  productMsCreatePaymentChannel?: Maybe<PaymentChannel>;
  productMsCreatePaymentChannelDenomination?: Maybe<PaymentChannelDenomination>;
  productMsCreatePaymentChannelGuideline?: Maybe<PaymentChannelGuideline>;
  productMsCreatePaymentProvider?: Maybe<PaymentProvider>;
  productMsCreateProductDenomination?: Maybe<ProductDenomination>;
  productMsCreateProductPage?: Maybe<ProductPage>;
  productMsCreateProductPriceList?: Maybe<ProductPriceList>;
  productMsCreateRateCardTemplate?: Maybe<RateCardTemplate>;
  productMsCreateRateCardTemplateDetails?: Maybe<RateCardTemplate>;
  productMsDeleteContractTemplate?: Maybe<ContractTemplate>;
  productMsDeleteContractTemplateDetail?: Maybe<ContractTemplateDetail>;
  productMsDeleteMerchantContract?: Maybe<MerchantContract>;
  productMsDeletePaymentChannel?: Maybe<PaymentChannel>;
  productMsDeletePaymentChannelGuideline?: Maybe<PaymentChannelGuideline>;
  productMsDeletePaymentProvider?: Maybe<PaymentProvider>;
  productMsDeleteProductPriceList?: Maybe<ProductPriceList>;
  productMsDeleteRateCardTemplate?: Maybe<Scalars['String']['output']>;
  productMsDeleteRateCardTemplateDetail?: Maybe<Scalars['String']['output']>;
  productMsUpdateContractTemplate?: Maybe<ContractTemplate>;
  productMsUpdateContractTemplateDetail?: Maybe<ContractTemplateDetail>;
  productMsUpdateMerchantContract?: Maybe<MerchantContract>;
  productMsUpdateMerchantPaymentDenomination?: Maybe<MerchantPaymentDenomination>;
  productMsUpdateMerchantPaymentProvider?: Maybe<MerchantPaymentProvider>;
  productMsUpdatePaymentChannel?: Maybe<PaymentChannel>;
  productMsUpdatePaymentChannelDenomination?: Maybe<PaymentChannelDenomination>;
  productMsUpdatePaymentProvider?: Maybe<PaymentProvider>;
  productMsUpdateProductDenomination?: Maybe<ProductDenomination>;
  productMsUpdateProductPage?: Maybe<ProductPage>;
  productMsUpdateProductPriceList?: Maybe<ProductPriceList>;
  productMsUpdateRateCardTemplate?: Maybe<RateCardTemplate>;
  productMsUpdateRateCardTemplateDetail?: Maybe<RateCardTemplate>;
  secretMsCreateCredential?: Maybe<Credential>;
  secretMsDeleteCredential?: Maybe<Scalars['String']['output']>;
  secretMsUpdateCredential?: Maybe<Credential>;
  voucherMsBoughtVoucher?: Maybe<Voucher>;
  voucherMsCreateVoucher?: Maybe<Voucher>;
  voucherMsCreateVoucherGroup?: Maybe<VoucherGroup>;
  voucherMsCreateVoucherGroupAutoGen?: Maybe<VoucherGroupAutoGen>;
  voucherMsCreateVoucherGroupGenLock?: Maybe<IsSuccess>;
  voucherMsDeleteVoucherGroup?: Maybe<VoucherGroup>;
  voucherMsDeleteVoucherGroupAutoGen?: Maybe<Message>;
  voucherMsGenerateVoucher?: Maybe<Message>;
  voucherMsRedeemVoucher?: Maybe<Voucher>;
  voucherMsTriggerVoucherGroupAutoGen?: Maybe<Message>;
  voucherMsUpdateVoucherGroup?: Maybe<VoucherGroup>;
  voucherMsUpdateVoucherGroupAutoGen?: Maybe<VoucherGroupAutoGen>;
  voucherMsVoidVoucher?: Maybe<Scalars['String']['output']>;
  webConfigMsCreateWebConfig?: Maybe<WebConfig>;
  webConfigMsSetDefaultLangCode?: Maybe<Country>;
  webConfigMsUpdateSupportLanguage?: Maybe<Scalars['String']['output']>;
  webConfigMsUpdateWebConfig?: Maybe<WebConfig>;
  webtopupMsDeleteWebtopupTrx?: Maybe<WebtopupTransaction>;
  webtopupMsInitWebtopupTrx?: Maybe<WebtopupResponse>;
};


export type MutationCmsMsCreateAuthorHistoricalSlugArgs = {
  input?: InputMaybe<CreateAuthorHistoricalSlugRq>;
};


export type MutationApprovalMsApproveOrDeclineRequestArgs = {
  approvalGroupGuid?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  isApprove?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApprovalMsCreateApprovalRequestArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateApprovalRq>>>;
};


export type MutationAuditMsCreateAuditTrailArgs = {
  input?: InputMaybe<CreateAuditTrailRq>;
};


export type MutationAuditMsCreateSuspiciousTagArgs = {
  input?: InputMaybe<CreateSuspiciousTagRq>;
};


export type MutationAuditMsDeleteSuspiciousTagArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuditMsUpdateSuspiciousTagArgs = {
  input?: InputMaybe<UpdateSuspiciousTagRq>;
};


export type MutationAuthMsAttachPermToRoleArgs = {
  input: AttachPermRq;
};


export type MutationAuthMsAttachRolesToUsersArgs = {
  expiredDuration: Scalars['Int']['input'];
  roleGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subjectGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAuthMsChangePasswordArgs = {
  input: ChangePassRq;
};


export type MutationAuthMsCreateApiCredentialArgs = {
  input: CreateApiCredentialRq;
};


export type MutationAuthMsCreateAuthSettingsArgs = {
  input?: InputMaybe<CreateAuthSettingRq>;
};


export type MutationAuthMsCreateCompanyArgs = {
  input?: InputMaybe<CreateCompanyRq>;
};


export type MutationAuthMsCreateMerchantArgs = {
  input?: InputMaybe<CreateMerchantRq>;
};


export type MutationAuthMsCreatePermissionArgs = {
  input: CreatePermRq;
};


export type MutationAuthMsCreateRoleArgs = {
  input: CreateRoleRq;
};


export type MutationAuthMsCreateUserProfileArgs = {
  input?: InputMaybe<CreateUserRq>;
};


export type MutationAuthMsDeleteApiCredentialArgs = {
  guid: Scalars['String']['input'];
};


export type MutationAuthMsDeleteAuthSettingsArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthMsDeleteCompanyArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthMsDeleteMerchantArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthMsDeletePermissionArgs = {
  permGuid: Scalars['String']['input'];
};


export type MutationAuthMsDeleteRoleArgs = {
  guid: Scalars['String']['input'];
};


export type MutationAuthMsDetachPermToRoleArgs = {
  input: DetachPermRq;
};


export type MutationAuthMsExtendsRolesToUsersExpiredDateArgs = {
  extendDuration: Scalars['Int']['input'];
  roleGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subjectGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAuthMsForgotPasswordArgs = {
  input: ForgotPassRq;
};


export type MutationAuthMsForgotPasswordOtpArgs = {
  input: ForgotPassOtpRq;
};


export type MutationAuthMsLinkCompanyToMerchantsArgs = {
  companyGuid: Scalars['String']['input'];
  merchantGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAuthMsLinkCompanyToUsersArgs = {
  companyGuid?: InputMaybe<Scalars['String']['input']>;
  userGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAuthMsLinkMerchantsToUsersArgs = {
  merchantGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAuthMsLoginArgs = {
  input: LoginRq;
};


export type MutationAuthMsRefreshAccessTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationAuthMsRegisterArgs = {
  input: RegistrationRq;
};


export type MutationAuthMsResendEmailVerifArgs = {
  email: Scalars['String']['input'];
  sourcePlatform: SourcePlatform;
};


export type MutationAuthMsResendMobileVerifArgs = {
  mobileNum: Scalars['String']['input'];
  sourcePlatform: SourcePlatform;
};


export type MutationAuthMsRevokeRolesInUsersArgs = {
  roleGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAuthMsSocialLoginArgs = {
  input: SocialLoginRq;
};


export type MutationAuthMsTemporaryUserDeactivationArgs = {
  input?: InputMaybe<TemporaryUserDeactivationRq>;
};


export type MutationAuthMsUnLinkCompanyFromUsersArgs = {
  companyGuid?: InputMaybe<Scalars['String']['input']>;
  userGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAuthMsUnlinkCompanyFromMerchantsArgs = {
  companyGuid: Scalars['String']['input'];
  merchantGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAuthMsUnlinkMerchantsFromUsersArgs = {
  merchantGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAuthMsUpdateApiCredentialArgs = {
  input: UpdateApiCredentialRq;
};


export type MutationAuthMsUpdateAuthSettingsArgs = {
  input?: InputMaybe<UpdateAuthSettingRq>;
};


export type MutationAuthMsUpdateCompanyArgs = {
  input?: InputMaybe<UpdateCompanyRq>;
};


export type MutationAuthMsUpdateMerchantArgs = {
  input?: InputMaybe<UpdateMerchantRq>;
};


export type MutationAuthMsUpdatePermissionArgs = {
  guid: Scalars['String']['input'];
  input: UpdatePermRq;
};


export type MutationAuthMsUpdatePrincipalForAdminArgs = {
  input?: InputMaybe<UpdatePrincipalRq>;
};


export type MutationAuthMsUpdateRoleArgs = {
  guid: Scalars['String']['input'];
  input: UpdateRoleRq;
};


export type MutationAuthMsUpdateUserForAdminArgs = {
  input?: InputMaybe<UpdateProfileRq>;
};


export type MutationAuthMsUpdateUserPrincipalByOwnerArgs = {
  input?: InputMaybe<UpdatePrincipalRq>;
};


export type MutationAuthMsUpdateUserPrincipalOtpArgs = {
  newPrincipal?: InputMaybe<Scalars['String']['input']>;
  sendTo: Scalars['String']['input'];
};


export type MutationAuthMsUpdateUserProfileArgs = {
  input?: InputMaybe<UpdateProfileRq>;
};


export type MutationAuthMsUserConfirmArgs = {
  input: UserConfirmRq;
};


export type MutationCmsMsAssignTermToPostArgs = {
  input: CreateCmsPostTermRelationshipRq;
};


export type MutationCmsMsCreateBookmarkArgs = {
  input?: InputMaybe<CreateBookmarkRq>;
};


export type MutationCmsMsCreateCommentArgs = {
  input: CreateCmsPostCommentRq;
};


export type MutationCmsMsCreatePostArgs = {
  input: CreateCmsPostRq;
};


export type MutationCmsMsCreatePostExtsArgs = {
  input: CreateCmsPostExtRq;
};


export type MutationCmsMsCreatePostHistoricalSlugArgs = {
  input: CreatePostHistoricalSlugRq;
};


export type MutationCmsMsCreatePostTermArgs = {
  input: CreateCmsPostTermRq;
};


export type MutationCmsMsCreatePostViewsArgs = {
  postGuid: Scalars['String']['input'];
};


export type MutationCmsMsCreateReactionArgs = {
  input: CreateCmsReactionRq;
};


export type MutationCmsMsCreateUserArgs = {
  input: CreateCmsUserRq;
};


export type MutationCmsMsDeleteBookmarkArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCmsMsDeleteCommentArgs = {
  guid: Scalars['String']['input'];
};


export type MutationCmsMsDeletePostArgs = {
  guid: Scalars['String']['input'];
};


export type MutationCmsMsDeletePostExtsArgs = {
  guid: Scalars['String']['input'];
};


export type MutationCmsMsDeletePostTermArgs = {
  guids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationCmsMsDeleteUserArgs = {
  guid: Scalars['String']['input'];
  subject_guid: Scalars['String']['input'];
};


export type MutationCmsMsLockingPostArgs = {
  postGuid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCmsMsRemoveTermFromPostArgs = {
  guid: Scalars['String']['input'];
};


export type MutationCmsMsUpdateBookmarkArgs = {
  input?: InputMaybe<UpdateBookmarkRq>;
};


export type MutationCmsMsUpdatePostArgs = {
  input: UpdateCmsPostRq;
};


export type MutationCmsMsUpdatePostExtsArgs = {
  input: UpdateCmsPostExtRq;
};


export type MutationCmsMsUpdatePostTermArgs = {
  input: UpdateCmsPostTermRq;
};


export type MutationCmsMsUpdateUserArgs = {
  guid: Scalars['String']['input'];
  input: UpdateCmsUserRq;
};


export type MutationConsentMsConsentToAgreeArgs = {
  input?: InputMaybe<CreateConsentToAgreeRq>;
};


export type MutationConsentMsCreateHistoryAgreementArgs = {
  input?: InputMaybe<CreateHistoryAgreementRq>;
};


export type MutationConsentMsUpdateHistoryAgreementArgs = {
  input?: InputMaybe<UpdateHistoryAgreementRq>;
};


export type MutationDeletePaymentProviderExtArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFileMgmtSysMsFileAccessControlArgs = {
  input?: InputMaybe<TempFileRequest>;
};


export type MutationFileMgmtSysMsFileDeletionArgs = {
  fileGuid?: InputMaybe<Scalars['String']['input']>;
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationFileMgmtSysMsFileDownloadArgs = {
  input?: InputMaybe<TempFileRequest>;
};


export type MutationFileMgmtSysMsFileNotificationArgs = {
  input?: InputMaybe<TempFileRequest>;
};


export type MutationFileMgmtSysMsFileSharingArgs = {
  input?: InputMaybe<TempFileRequest>;
};


export type MutationFileMgmtSysMsFileStreamingArgs = {
  input?: InputMaybe<TempFileRequest>;
};


export type MutationFileMgmtSysMsFileUploadArgs = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationFileMgmtSysMsFileVersioningArgs = {
  input?: InputMaybe<TempFileRequest>;
};


export type MutationGgwMsCheckoutArgs = {
  data?: InputMaybe<CheckoutRequest>;
};


export type MutationGgwMsCreateGameTransactionArgs = {
  input?: InputMaybe<GameTransactionCreateRequest>;
};


export type MutationGgwMsDeleteGameTransactionArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGgwMsDeliveryArgs = {
  data?: InputMaybe<DeliveryRequest>;
};


export type MutationGgwMsInquiryArgs = {
  data?: InputMaybe<InquiryRequest>;
};


export type MutationGgwMsUpdateGameTransactionArgs = {
  input?: InputMaybe<GameTransactionUpdateRequest>;
};


export type MutationHumanResourcesMsApplyArgs = {
  input?: InputMaybe<ApplyVacancyRq>;
};


export type MutationHumanResourcesMsCreateVacancyArgs = {
  input?: InputMaybe<CreateVacancyRq>;
};


export type MutationHumanResourcesMsCreateVacancySettingsArgs = {
  input?: InputMaybe<CreateVacancySettingsRq>;
};


export type MutationHumanResourcesMsDeleteVacancyArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationHumanResourcesMsDeleteVacancySettingsArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationHumanResourcesMsUpdateVacancyArgs = {
  input?: InputMaybe<UpdateVacancyRq>;
};


export type MutationHumanResourcesMsUpdateVacancySettingsArgs = {
  input?: InputMaybe<UpdateVacancySettingsRq>;
};


export type MutationMembershipMsAssignTierToMemberArgs = {
  input?: InputMaybe<AssignTierToMember>;
};


export type MutationMembershipMsBanUserArgs = {
  input?: InputMaybe<NewMemberBan>;
};


export type MutationMembershipMsCreateBirthdayTierBonusRuleArgs = {
  input?: InputMaybe<NewBirthdayTierBonusRule>;
};


export type MutationMembershipMsCreateCatalogArgs = {
  input?: InputMaybe<NewCatalog>;
};


export type MutationMembershipMsCreateCatalogCategoryArgs = {
  input?: InputMaybe<NewCatalogCategory>;
};


export type MutationMembershipMsCreateMemberPointArgs = {
  input?: InputMaybe<NewMemberPoint>;
};


export type MutationMembershipMsCreateMemberPointMutationArgs = {
  input?: InputMaybe<NewMemberPointMutation>;
};


export type MutationMembershipMsCreateRedeemTransactionArgs = {
  input?: InputMaybe<NewRedeem>;
};


export type MutationMembershipMsCreateTierArgs = {
  input?: InputMaybe<NewTier>;
};


export type MutationMembershipMsCreateTierBonusRuleArgs = {
  input?: InputMaybe<NewTierBonusRule>;
};


export type MutationMembershipMsDeleteBirthdayTierBonusRuleArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMembershipMsDeleteCatalogArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMembershipMsDeleteCatalogCategoryArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMembershipMsDeleteCatalogExtArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMembershipMsDeleteTierArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMembershipMsDeleteTierBonusRuleArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMembershipMsDeleteTierExtArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMembershipMsUpdateBirthdayTierBonusRuleArgs = {
  input?: InputMaybe<UpdateBirthdayTierBonusRule>;
};


export type MutationMembershipMsUpdateCatalogArgs = {
  input?: InputMaybe<UpdateCatalog>;
};


export type MutationMembershipMsUpdateCatalogCategoryArgs = {
  input?: InputMaybe<UpdateCatalogCategory>;
};


export type MutationMembershipMsUpdateRedeemTransactionArgs = {
  input?: InputMaybe<UpdateRedeem>;
};


export type MutationMembershipMsUpdateTierArgs = {
  input?: InputMaybe<UpdateTier>;
};


export type MutationMembershipMsUpdateTierBonusRuleArgs = {
  input?: InputMaybe<UpdateTierBonusRule>;
};


export type MutationNotificationMsCreateEmailMessageTemplateArgs = {
  input?: InputMaybe<CreateMessageTemplateRq>;
};


export type MutationNotificationMsCreateNotificationAlertArgs = {
  input?: InputMaybe<CreateNotificationAlertRq>;
};


export type MutationNotificationMsCreateUserFcmArgs = {
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationNotificationMsUpdateEmailMessageTemplateArgs = {
  input?: InputMaybe<UpdateEmailMessageTemplateRq>;
};


export type MutationNotificationMsUpdateReadStatusArgs = {
  guid: Scalars['String']['input'];
};


export type MutationProductMsCreateContractTemplateArgs = {
  input?: InputMaybe<CreateContractTemplateRq>;
};


export type MutationProductMsCreateContractTemplateDetailArgs = {
  input?: InputMaybe<CreateTemplateDetailRq>;
};


export type MutationProductMsCreateMerchantContractArgs = {
  input?: InputMaybe<CreateMerchantContractRq>;
};


export type MutationProductMsCreateMerchantPaymentDenominationArgs = {
  input?: InputMaybe<CreateMerchantPaymentDenomRq>;
};


export type MutationProductMsCreateMerchantPaymentProviderArgs = {
  input?: InputMaybe<CreateMerchantPaymentProviderRq>;
};


export type MutationProductMsCreatePaymentChannelArgs = {
  input?: InputMaybe<CreatePaymentChannelRq>;
};


export type MutationProductMsCreatePaymentChannelDenominationArgs = {
  input?: InputMaybe<CreatePaymentChannelDenomRq>;
};


export type MutationProductMsCreatePaymentChannelGuidelineArgs = {
  input: CreatePaymentChannelGuidelineRq;
};


export type MutationProductMsCreatePaymentProviderArgs = {
  input?: InputMaybe<CreatePaymentProviderRq>;
};


export type MutationProductMsCreateProductDenominationArgs = {
  input?: InputMaybe<CreateProductDenominationRq>;
};


export type MutationProductMsCreateProductPageArgs = {
  input?: InputMaybe<CreateProductPageRq>;
};


export type MutationProductMsCreateProductPriceListArgs = {
  input: CreateProductPriceListRq;
};


export type MutationProductMsCreateRateCardTemplateArgs = {
  input?: InputMaybe<CreateRateCardTemplateRq>;
};


export type MutationProductMsCreateRateCardTemplateDetailsArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateRateCardTemplateDetailsRq>>>;
  rateTemplateGuid: Scalars['String']['input'];
};


export type MutationProductMsDeleteContractTemplateArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductMsDeleteContractTemplateDetailArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductMsDeleteMerchantContractArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductMsDeletePaymentChannelArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductMsDeletePaymentChannelGuidelineArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductMsDeletePaymentProviderArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductMsDeleteProductPriceListArgs = {
  guid: Scalars['String']['input'];
};


export type MutationProductMsDeleteRateCardTemplateArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductMsDeleteRateCardTemplateDetailArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductMsUpdateContractTemplateArgs = {
  input?: InputMaybe<UpdateContractTemplateRq>;
};


export type MutationProductMsUpdateContractTemplateDetailArgs = {
  input?: InputMaybe<UpdateTemplateDetailRq>;
};


export type MutationProductMsUpdateMerchantContractArgs = {
  input?: InputMaybe<UpdateMerchantContractRq>;
};


export type MutationProductMsUpdateMerchantPaymentDenominationArgs = {
  input?: InputMaybe<UpdateMerchantPaymentDenomRq>;
};


export type MutationProductMsUpdateMerchantPaymentProviderArgs = {
  input?: InputMaybe<UpdateMerchantPaymentProviderRq>;
};


export type MutationProductMsUpdatePaymentChannelArgs = {
  input?: InputMaybe<UpdatePaymentChannelRq>;
};


export type MutationProductMsUpdatePaymentChannelDenominationArgs = {
  input?: InputMaybe<UpdatePaymentChannelDenomRq>;
};


export type MutationProductMsUpdatePaymentProviderArgs = {
  input?: InputMaybe<UpdatePaymentProviderRq>;
};


export type MutationProductMsUpdateProductDenominationArgs = {
  input?: InputMaybe<UpdateProductDenominationRq>;
};


export type MutationProductMsUpdateProductPageArgs = {
  input?: InputMaybe<UpdateProductPageRq>;
};


export type MutationProductMsUpdateProductPriceListArgs = {
  input: UpdateProductPriceListRq;
};


export type MutationProductMsUpdateRateCardTemplateArgs = {
  input?: InputMaybe<UpdateRateCardTemplateRq>;
};


export type MutationProductMsUpdateRateCardTemplateDetailArgs = {
  input?: InputMaybe<UpdateRateCardTemplateDetailRq>;
};


export type MutationSecretMsCreateCredentialArgs = {
  input?: InputMaybe<NewCredentialRq>;
};


export type MutationSecretMsDeleteCredentialArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSecretMsUpdateCredentialArgs = {
  input?: InputMaybe<UpdateCredentialRq>;
};


export type MutationVoucherMsBoughtVoucherArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVoucherMsCreateVoucherArgs = {
  input?: InputMaybe<CreateVoucherRq>;
};


export type MutationVoucherMsCreateVoucherGroupArgs = {
  input?: InputMaybe<CreateVoucherGroupRq>;
};


export type MutationVoucherMsCreateVoucherGroupAutoGenArgs = {
  input?: InputMaybe<CreateVoucherGroupAutoGenRq>;
};


export type MutationVoucherMsCreateVoucherGroupGenLockArgs = {
  input?: InputMaybe<VoucherGroupAutoGenLockRq>;
};


export type MutationVoucherMsDeleteVoucherGroupArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVoucherMsDeleteVoucherGroupAutoGenArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVoucherMsGenerateVoucherArgs = {
  input?: InputMaybe<GenerateVoucherRq>;
};


export type MutationVoucherMsRedeemVoucherArgs = {
  id?: InputMaybe<VoucherId>;
};


export type MutationVoucherMsTriggerVoucherGroupAutoGenArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVoucherMsUpdateVoucherGroupArgs = {
  input?: InputMaybe<UpdateVoucherGroupRq>;
};


export type MutationVoucherMsUpdateVoucherGroupAutoGenArgs = {
  input?: InputMaybe<UpdateVoucherGroupAutoGenRq>;
};


export type MutationVoucherMsVoidVoucherArgs = {
  guid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationWebConfigMsCreateWebConfigArgs = {
  input?: InputMaybe<CreateWebConfigRq>;
};


export type MutationWebConfigMsSetDefaultLangCodeArgs = {
  countryGuid?: InputMaybe<Scalars['String']['input']>;
  langCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWebConfigMsUpdateSupportLanguageArgs = {
  countryGuid?: InputMaybe<Scalars['String']['input']>;
  langCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWebConfigMsUpdateWebConfigArgs = {
  input?: InputMaybe<UpdateWebConfigRq>;
};


export type MutationWebtopupMsDeleteWebtopupTrxArgs = {
  guid: Scalars['String']['input'];
};


export type MutationWebtopupMsInitWebtopupTrxArgs = {
  input: WebtopupRequest;
};

export type NewBirthdayTierBonusRule = {
  tierGuid: Scalars['String']['input'];
  type: BirthdayTierBonusRuleTypeEnum;
  value: Scalars['Float']['input'];
};

export type NewCatalog = {
  categoryGuids: Array<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  currencyCode: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  estDeliveryTimeUnit?: InputMaybe<EstDeliveryTimeUnit>;
  estDeliveryTimeValue?: InputMaybe<Scalars['Int']['input']>;
  isNeedApproval?: Scalars['Boolean']['input'];
  minLevelToReach?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
};

export type NewCatalogCategory = {
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type NewCredentialRq = {
  code: Scalars['String']['input'];
  companyGuid: Scalars['String']['input'];
  type: CredentialType;
  value: Scalars['String']['input'];
};

export type NewMemberBan = {
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  memberGuid: Scalars['String']['input'];
  type: MemberBanType;
};

export type NewMemberPoint = {
  amountSpent?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  memberGuid: Scalars['String']['input'];
  pointRewarded?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  transactionRewardRef?: InputMaybe<Scalars['String']['input']>;
  type?: MemberPointTypeEnum;
};

export type NewMemberPointMutation = {
  countryId: Scalars['String']['input'];
  currencyCode: Scalars['String']['input'];
  isSystem: Scalars['Boolean']['input'];
  memberGuid: Scalars['String']['input'];
  memberPointGuid?: InputMaybe<Scalars['String']['input']>;
  pointAdd?: InputMaybe<Scalars['Float']['input']>;
  pointSubstract?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  transactionDate?: InputMaybe<Scalars['DateTime']['input']>;
  transactionSpentRef?: InputMaybe<Scalars['String']['input']>;
  type: MemberPointMutationTypeEnum;
};

export type NewRedeem = {
  catalogGuid: Scalars['String']['input'];
  memberGuid: Scalars['String']['input'];
};

export type NewTier = {
  benefitField?: InputMaybe<Scalars['JSON']['input']>;
  countryCode: Scalars['String']['input'];
  levelValue: Scalars['Int']['input'];
  minPointToKeep: Scalars['Int']['input'];
  minPointToReach: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type NewTierBonusRule = {
  baseValue: TierBonusRuleBaseValueEnum;
  isForBirthday?: Scalars['Boolean']['input'];
  isForReferral?: Scalars['Boolean']['input'];
  maximumAmount: Scalars['Long']['input'];
  minimumAmount: Scalars['Int']['input'];
  priority: Scalars['Int']['input'];
  stopNow: Scalars['Boolean']['input'];
  tierGuid: Scalars['String']['input'];
  type: TierBonusRuleTypeEnum;
  value: Scalars['Float']['input'];
};

export enum NotifAlertStatusEnum {
  Danger = 'DANGER',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type NotificationAlert = {
  __typename?: 'NotificationAlert';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  receiverCompanyGuid?: Maybe<Scalars['String']['output']>;
  receiverGuid?: Maybe<Scalars['String']['output']>;
  receiverMerchantGuid?: Maybe<Scalars['String']['output']>;
  receiverPermissionCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<NotifAlertStatusEnum>;
  targetGuid: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<AlertTypeEnum>;
};

export type NotificationAlertCriteria = {
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  isRead?: Scalars['Boolean']['input'];
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  receiverCompanyGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  receiverGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  receiverMerchantGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  receiverPermissionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: InputMaybe<Array<NotifAlertStatusEnum>>;
  targetGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  targetTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<AlertTypeEnum>>;
};

export type Option = {
  __typename?: 'Option';
  display?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** Field endCursor */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Field hasNextPage */
  hasNextPage: Scalars['Boolean']['output'];
  /** Field hasPreviousPage */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Field startCursor */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageableResponse = {
  __typename?: 'PageableResponse';
  data?: Maybe<Array<Maybe<Approval>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type PageableRs = {
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type PaginationPermissionResponse = {
  __typename?: 'PaginationPermissionResponse';
  data: Array<Maybe<AppPermDfn>>;
  totalRecord: Scalars['Int']['output'];
};

export type PaginationRoleResponse = {
  __typename?: 'PaginationRoleResponse';
  data: Array<Maybe<AppLoginRole>>;
  totalRecord: Scalars['Int']['output'];
};

export type PaginationVacancyApplicationResponse = {
  __typename?: 'PaginationVacancyApplicationResponse';
  data: Array<Maybe<VacancyApplication>>;
  totalRecord: Scalars['Int']['output'];
};

export type PaginationVacancyResponse = {
  __typename?: 'PaginationVacancyResponse';
  data: Array<Maybe<Vacancy>>;
  totalRecord: Scalars['Int']['output'];
};

export type PaymentChannel = {
  __typename?: 'PaymentChannel';
  category?: Maybe<Scalars['String']['output']>;
  charge?: Maybe<Scalars['Float']['output']>;
  chargeType?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  companyCredentialGuid?: Maybe<Scalars['String']['output']>;
  contractorCompanyGuid?: Maybe<Scalars['String']['output']>;
  countryByCode?: Maybe<Country>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBySubjectGuid?: Maybe<Scalars['String']['output']>;
  credentialPaymentChannel?: Maybe<Credential>;
  currencyByCode?: Maybe<Currency>;
  field?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  isWhitelabel?: Maybe<Scalars['Boolean']['output']>;
  maxAmount?: Maybe<Scalars['Long']['output']>;
  metaFieldJson?: Maybe<Scalars['JSON']['output']>;
  minAmount?: Maybe<Scalars['Long']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parameter?: Maybe<Scalars['String']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  providerCompanyGuid?: Maybe<Scalars['String']['output']>;
  providerPriority?: Maybe<Scalars['String']['output']>;
  rateTemplate?: Maybe<Array<Maybe<RateCardTemplate>>>;
  remark?: Maybe<Scalars['String']['output']>;
  requiredFieldJson?: Maybe<Scalars['JSON']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  serviceCompanyGuid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBySubjectGuid?: Maybe<Scalars['String']['output']>;
  vatPercentage?: Maybe<Scalars['Float']['output']>;
};

export type PaymentChannelDenomQueryCriteria = {
  amount?: InputMaybe<Scalars['Double']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['Long']['input']>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  paymentChannelGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentChannelDenomination = {
  __typename?: 'PaymentChannelDenomination';
  amount?: Maybe<Scalars['Double']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  credit?: Maybe<Scalars['Long']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  paymentChannelGuid?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentChannelDetail = {
  __typename?: 'PaymentChannelDetail';
  file?: Maybe<FetchFileResponse>;
  logo?: Maybe<Scalars['String']['output']>;
};

export type PaymentChannelGuideline = {
  __typename?: 'PaymentChannelGuideline';
  guid: Scalars['String']['output'];
  paymentChannelGuid: Scalars['String']['output'];
  post?: Maybe<CmsPost>;
};

export type PaymentChannelGuidelineQueryCriteria = {
  guid?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  paymentChannelGuid?: InputMaybe<Scalars['String']['input']>;
  postGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentChannelMetaField = {
  apiType: Array<PaymentChannelMetaFieldApiEnum>;
  desc?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum PaymentChannelMetaFieldApiEnum {
  Callback = 'CALLBACK',
  CreateOrder = 'CREATE_ORDER',
  Inquiry = 'INQUIRY',
  Otp = 'OTP'
}

export type PaymentChannelPublic = {
  __typename?: 'PaymentChannelPublic';
  code?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  providerPriority?: Maybe<Scalars['String']['output']>;
  requiredFieldJson?: Maybe<Scalars['JSON']['output']>;
};

export type PaymentChannelPublicRs = {
  __typename?: 'PaymentChannelPublicRs';
  data?: Maybe<Array<Maybe<PaymentChannelPublic>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type PaymentChannelQueryCriteria = {
  category?: InputMaybe<Scalars['String']['input']>;
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  chargeType?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  companyCredentialGuid?: InputMaybe<Scalars['String']['input']>;
  contractorCompanyGuid?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmount?: InputMaybe<Scalars['Long']['input']>;
  minAmount?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  providerCode?: InputMaybe<Scalars['String']['input']>;
  providerCompanyGuid?: InputMaybe<Scalars['String']['input']>;
  providerPriority?: InputMaybe<Scalars['String']['input']>;
  rateTemplateGuid?: InputMaybe<Scalars['String']['input']>;
  serviceCompanyGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentChannelRs = {
  __typename?: 'PaymentChannelRs';
  data?: Maybe<Array<Maybe<PaymentChannel>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type PaymentProvider = {
  __typename?: 'PaymentProvider';
  category?: Maybe<Scalars['String']['output']>;
  ccyCode?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  exts?: Maybe<Array<Maybe<PaymentProviderExt>>>;
  guid?: Maybe<Scalars['String']['output']>;
  maxAmount?: Maybe<Scalars['Long']['output']>;
  minAmount?: Maybe<Scalars['Long']['output']>;
  providerExternalName?: Maybe<Scalars['String']['output']>;
  providerInternalName?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
};

export type PaymentProviderExt = {
  __typename?: 'PaymentProviderExt';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByGuid?: Maybe<Scalars['String']['output']>;
  extType?: Maybe<Scalars['String']['output']>;
  extValue?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FetchFileResponse>;
  guid?: Maybe<Scalars['String']['output']>;
  paymentProviderGuid?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByGuid?: Maybe<Scalars['String']['output']>;
};

export type PaymentProviderQueryCriteria = {
  category?: InputMaybe<Scalars['String']['input']>;
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxAmount?: InputMaybe<Scalars['Long']['input']>;
  minAmount?: InputMaybe<Scalars['Long']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  providerExternalName?: InputMaybe<Scalars['String']['input']>;
  providerInternalName?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentProviderRs = {
  __typename?: 'PaymentProviderRs';
  data?: Maybe<Array<Maybe<PaymentProvider>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type PermissionCheckRq = {
  /**  ... user guid */
  subjectGuid: Scalars['String']['input'];
  /**  ... target permission that want to check */
  targetPerms: Array<InputMaybe<Scalars['String']['input']>>;
};

export type PermissionFilter = {
  /**  ...get permission by perm guid */
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /**  ... filter permission by perCode equal */
  permCode?: InputMaybe<Scalars['String']['input']>;
  /**  ... filter permission by description ilike */
  permDescription?: InputMaybe<Scalars['String']['input']>;
  /**  ... filter permission by permission module in */
  permModule?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  ... filter permission by name ilike */
  permName?: InputMaybe<Scalars['String']['input']>;
  /**  ... filter for perm scope equal */
  permScope?: InputMaybe<Scalars['String']['input']>;
  /**  ... filter permission by permType in */
  permType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  ... filter permission by related micro fe equal */
  relatedMf?: InputMaybe<Scalars['String']['input']>;
  /**  ... filter permission by role(s) */
  roleGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  /**  ... filter permission by status equal */
  status?: Status;
  /**  ...get permission by user guid */
  subjectGuid?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneCode = {
  __typename?: 'PhoneCode';
  code?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type Post = {
  __typename?: 'Post';
  postGuid?: Maybe<Scalars['String']['output']>;
  urlKey?: Maybe<Scalars['String']['output']>;
};

export type PostHistoricalSlug = {
  __typename?: 'PostHistoricalSlug';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  postGuid?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type PostHistoricalSlugCriteria = {
  guid?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  postGuid?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostHistoricalSlugResult = {
  __typename?: 'PostHistoricalSlugResult';
  data: Array<Maybe<PostHistoricalSlug>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum PostStatus {
  Draft = 'DRAFT',
  OnReview = 'ON_REVIEW',
  Published = 'PUBLISHED'
}

export enum PriceListType {
  Directtopup = 'DIRECTTOPUP',
  Unibox = 'UNIBOX',
  Webtopup = 'WEBTOPUP'
}

export enum PrincipalStatus {
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  UserConfirmed = 'USER_CONFIRMED',
  UserUnconfirmed = 'USER_UNCONFIRMED'
}

export type ProductDenomination = {
  __typename?: 'ProductDenomination';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  imagePath?: Maybe<Scalars['String']['output']>;
  isAdjustableSellingPrice?: Maybe<Scalars['Boolean']['output']>;
  isDirectVoucher?: Maybe<Scalars['Boolean']['output']>;
  isVoucherApi?: Maybe<Scalars['Boolean']['output']>;
  itemCode?: Maybe<Scalars['String']['output']>;
  merchantGuid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerProductId?: Maybe<Scalars['String']['output']>;
  productPageGuid?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<VoucherGroup>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
};

export type ProductDenominationQueryCriteria = {
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isAdjustableSellingPrice?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectVoucher?: InputMaybe<Scalars['Boolean']['input']>;
  isVoucherApi?: InputMaybe<Scalars['Boolean']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  partnerProductId?: InputMaybe<Scalars['String']['input']>;
  productPageGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ProductDetailsResponse = {
  __typename?: 'ProductDetailsResponse';
  denominations?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  gameRequiredField?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  product?: Maybe<Scalars['JSON']['output']>;
};

export type ProductPage = {
  __typename?: 'ProductPage';
  advanceSearch?: Maybe<Scalars['String']['output']>;
  category?: Maybe<ProductPageCategory>;
  communityLink?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  companyGuid?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  credentialProductPage?: Maybe<Credential>;
  denominations?: Maybe<Array<Maybe<ProductDenomination>>>;
  downloadLink?: Maybe<Scalars['String']['output']>;
  gameCenterImage?: Maybe<Scalars['String']['output']>;
  gameChildCode?: Maybe<Scalars['String']['output']>;
  gameParentCode?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  huaweiDownloadLink?: Maybe<Scalars['String']['output']>;
  iconPath?: Maybe<Scalars['String']['output']>;
  influencerLink?: Maybe<Scalars['String']['output']>;
  iosDownloadLink?: Maybe<Scalars['String']['output']>;
  isEvent?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isPromo?: Maybe<Scalars['Boolean']['output']>;
  isShowOnLandingPage?: Maybe<Scalars['Boolean']['output']>;
  isTesting?: Maybe<Scalars['Boolean']['output']>;
  merchant?: Maybe<Merchant>;
  merchantGuid?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaFieldJson?: Maybe<Scalars['JSON']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  officialSiteLink?: Maybe<Scalars['String']['output']>;
  providerCompanyGuid?: Maybe<Scalars['String']['output']>;
  requiredFieldJson?: Maybe<Scalars['JSON']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  schemaMarkUp?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  topUpGuideLink?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
};

export enum ProductPageCategory {
  Voucher = 'VOUCHER',
  Webtopup = 'WEBTOPUP'
}

/** ProductPage Connection */
export type ProductPageConnection = {
  __typename?: 'ProductPageConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<ProductPageEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** ProductPage Edge */
export type ProductPageEdge = {
  __typename?: 'ProductPageEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Field node */
  node?: Maybe<ProductPage>;
};

export type ProductPageMetaField = {
  apiType: Array<ProductPageMetaFieldApiEnum>;
  desc?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductPageMetaFieldApiEnum {
  Checkout = 'CHECKOUT',
  Delivery = 'DELIVERY',
  Inquiry = 'INQUIRY',
  Server = 'SERVER'
}

export type ProductPageQueryCriteria = {
  companyGuid?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  gameChildCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gameParentCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isShowOnLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  providerCompanyGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPageQueryCriteriaPublic = {
  /** fill with end cursor id to get next data/page, cannot use this if already use 'before' filter */
  after?: InputMaybe<Scalars['String']['input']>;
  /** fill with start cursor id to get prev data/page, cannot use this if already use 'after' filter */
  before?: InputMaybe<Scalars['String']['input']>;
  companyGuid?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  gameChildCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gameParentCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isShowOnLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  pageSize?: Scalars['Int']['input'];
  sortBy: ProductPageSortByEnum;
  sortDirection?: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductPageSortByEnum {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export type ProductPriceList = {
  __typename?: 'ProductPriceList';
  ccyCode?: Maybe<Scalars['String']['output']>;
  contractTemplateGuid?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  eventCode?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  magnifyValue?: Maybe<Scalars['Int']['output']>;
  paymentProvider?: Maybe<PaymentProvider>;
  paymentProviderCode?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  productDenom?: Maybe<ProductDenomination>;
  productDenomGuid?: Maybe<Scalars['String']['output']>;
  productPage?: Maybe<ProductPage>;
  productPageGuid?: Maybe<Scalars['String']['output']>;
  rateTemplateGuid?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Status>;
  type?: Maybe<PriceListType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
};

export type ProductPriceListCriteria = {
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  contractTemplateGuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventCode?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  paymentProviderCode?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
  productPageGuid?: InputMaybe<Scalars['String']['input']>;
  rateTemplateGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: Status;
  type?: InputMaybe<PriceListType>;
};

export type ProductPriceListRs = PageableRs & {
  __typename?: 'ProductPriceListRs';
  data?: Maybe<Array<ProductPriceList>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum ProductSelectionEnum {
  All = 'ALL',
  Selective = 'SELECTIVE'
}

export enum ProviderPlatform {
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE'
}

export type Query = {
  __typename?: 'Query';
  approvalMsApprovals?: Maybe<PageableResponse>;
  /** get all audit trail with criteria */
  auditMsAuditTrail?: Maybe<Array<Maybe<AuditTrail>>>;
  /** get suspicious tags */
  auditMsSuspiciousTag?: Maybe<SuspiciousTagPageableRs>;
  /** acessToken query used by gateway to get user access permission */
  authMsAccessToken?: Maybe<Scalars['String']['output']>;
  /** Generate token from api credential */
  authMsApiCredentialToken?: Maybe<Scalars['String']['output']>;
  authMsApiCredentials?: Maybe<ApiCredentialFilterRs>;
  authMsApiCredentialsPrivate?: Maybe<Array<Maybe<ApiCredentialPrivate>>>;
  /** get all auth ms settings with filter */
  authMsAuthSettings?: Maybe<AuthSettingsWithFilterRs>;
  /** get all company with filter */
  authMsCompany?: Maybe<CompanyWithFilterRs>;
  /** This query allow to get firebase id token from uid (testing) */
  authMsGetFirebaseIdToken?: Maybe<FirebaseIdTokenRes>;
  /** get all member with criteria for CP_COMMERCE sourcePlatform */
  authMsMember?: Maybe<AppLoginSubjectConnection>;
  /** get all merchant by guid */
  authMsMerchant?: Maybe<MerchantFilterRs>;
  /** get user profile by authorization header */
  authMsMyProfile?: Maybe<AppLoginSubject>;
  /** get list of permission available */
  authMsPermission?: Maybe<PaginationPermissionResponse>;
  /** get list of available role */
  authMsRole?: Maybe<PaginationRoleResponse>;
  authMsSignatureChecker?: Maybe<SignatureCheckerRs>;
  authMsSignatureCreate?: Maybe<SignatureCreateRs>;
  /** This query allow to validate token */
  authMsTokenValidaton?: Maybe<Scalars['String']['output']>;
  /** get all user with criteria for ADMIN sourcePlatform */
  authMsUser?: Maybe<Array<Maybe<AppLoginSubject>>>;
  /**
   * Get Author Historical Slug by criteria
   * For urlKey use slug with pageSize 1
   */
  cmsMsAuthorHistoricalSlug?: Maybe<AuthorHistoricalSlugResult>;
  cmsMsBookmarks?: Maybe<Array<Maybe<CmsBookmarks>>>;
  cmsMsCommentReactions?: Maybe<CmsReactionResult>;
  /** This query is used to get post, comment and its reaction status based on its historical slug */
  cmsMsFindPostCommentReactionByHistSlug?: Maybe<CmsPost>;
  /** This query is used to get locked post by guid or post guid */
  cmsMsLockedPost?: Maybe<Array<Maybe<CmsLockPost>>>;
  cmsMsPostComments?: Maybe<CmsPostCommentResult>;
  cmsMsPostExts?: Maybe<Array<Maybe<CmsPostExt>>>;
  /**
   * This query is used to get post historical slug by criteria
   * can use 'slug' for search urlKey
   */
  cmsMsPostHistoricalSlug?: Maybe<PostHistoricalSlugResult>;
  cmsMsPostTermRelationship?: Maybe<Array<Maybe<CmsPostTermRelationship>>>;
  cmsMsPostTerms?: Maybe<CmsPostTermResult>;
  cmsMsPostViews?: Maybe<CmsPostViewsResult>;
  cmsMsPosts?: Maybe<CmsPostConnection>;
  cmsMsPostsPublic?: Maybe<CmsPostConnection>;
  cmsMsUsers?: Maybe<Array<Maybe<CmsUser>>>;
  consentMsHistoryAgreement?: Maybe<Array<Maybe<HistoryAgreement>>>;
  consentMsTableAgreement?: Maybe<Array<Maybe<Agreement>>>;
  consentMsUserConsent?: Maybe<Array<Maybe<UserConsent>>>;
  /**     remove this when there is field under query */
  emptyField?: Maybe<Scalars['String']['output']>;
  fileMgmtSysMsFetchFile?: Maybe<Array<Maybe<FetchFileResponse>>>;
  fileMgmtSysMsFileMetadata?: Maybe<Scalars['String']['output']>;
  fileMgmtSysMsFileQuota?: Maybe<Scalars['String']['output']>;
  fileMgmtSysMsFileSearch?: Maybe<Scalars['String']['output']>;
  ggwMsGameTransactions?: Maybe<Array<Maybe<GameTransactions>>>;
  ggwMsRequiredField?: Maybe<RequiredFieldResponse>;
  humanResourcesMsVacancy?: Maybe<PaginationVacancyResponse>;
  humanResourcesMsVacancyApplication?: Maybe<PaginationVacancyApplicationResponse>;
  humanResourcesMsVacancyPublic?: Maybe<PaginationVacancyResponse>;
  humanResourcesMsVacancySettings?: Maybe<Array<Maybe<VacancySettings>>>;
  membershipMsBirthdayTierBonusRules?: Maybe<BirthdayTierBonusRulesRs>;
  membershipMsCatalogCategories?: Maybe<CatalogCategoryRs>;
  membershipMsCatalogs?: Maybe<CatalogRs>;
  membershipMsMember?: Maybe<MemberPageableResponse>;
  membershipMsMemberPointMutations?: Maybe<MemberPointMutationsRs>;
  membershipMsMemberPointSummary?: Maybe<MemberPointSummaryRs>;
  membershipMsMemberPoints?: Maybe<MemberPointsRs>;
  membershipMsRedeemTransactions?: Maybe<RedeemTransactionRs>;
  membershipMsRewardPointPrediction?: Maybe<Scalars['Float']['output']>;
  membershipMsTierBonusRule?: Maybe<TierBonusRuleRs>;
  membershipMsTiers?: Maybe<TierRs>;
  /** get all message template with criteria */
  notificationMsEmailMessageTemplate?: Maybe<EmailMessageTemplatePageableResult>;
  notificationMsNotificationAlerts?: Maybe<Array<Maybe<NotificationAlert>>>;
  productMsContractTemplateDetails?: Maybe<ContractTemplateDetailRs>;
  productMsContractTemplates?: Maybe<ContractTemplateRs>;
  productMsMerchantContracts?: Maybe<MerchantContractRs>;
  productMsPaymentChannel?: Maybe<PaymentChannelRs>;
  productMsPaymentChannelDenomination?: Maybe<Array<Maybe<PaymentChannelDenomination>>>;
  productMsPaymentChannelGuideline?: Maybe<Array<Maybe<PaymentChannelGuideline>>>;
  productMsPaymentChannelPublic?: Maybe<PaymentChannelPublicRs>;
  productMsPaymentProvider?: Maybe<PaymentProviderRs>;
  productMsProductDenomination?: Maybe<Array<Maybe<ProductDenomination>>>;
  productMsProductPage?: Maybe<Array<Maybe<ProductPage>>>;
  productMsProductPagePublic?: Maybe<ProductPageConnection>;
  productMsProductPriceList?: Maybe<ProductPriceListRs>;
  productMsRateCardTemplates?: Maybe<RateTemplateRs>;
  secretMsCredentialTrails?: Maybe<CredentialTrailRs>;
  secretMsCredentials?: Maybe<CredentialRs>;
  voucherMsGatewayCreateOrder?: Maybe<VoucherGatewayResponse>;
  voucherMsVoucherGroup?: Maybe<VoucherGroupRs>;
  voucherMsVoucherGroupAutoGen?: Maybe<VoucherGroupAutoGenRs>;
  voucherMsVoucherGroupAutoGenLock?: Maybe<VoucherGroupAutoGenLock>;
  voucherMsVouchers?: Maybe<VouchersRs>;
  webConfigMsCountry?: Maybe<CountryResult>;
  webConfigMsCurrency?: Maybe<CurrencyResult>;
  webConfigMsWebConfig?: Maybe<WebConfigResult>;
  webtopupMsGetProductPage?: Maybe<ProductDetailsResponse>;
  webtopupMsTransactionHistory?: Maybe<Array<Maybe<WebtopupTransactionHistory>>>;
  webtopupMsTransactions?: Maybe<WebtopupTransactionResult>;
};


export type QueryApprovalMsApprovalsArgs = {
  input?: InputMaybe<ApprovalCriteria>;
};


export type QueryAuditMsAuditTrailArgs = {
  input?: InputMaybe<AuditTrailCriteria>;
};


export type QueryAuditMsSuspiciousTagArgs = {
  input?: InputMaybe<SuspiciousFilter>;
};


export type QueryAuthMsAccessTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryAuthMsApiCredentialTokenArgs = {
  accessKey: Scalars['String']['input'];
  secretKey: Scalars['String']['input'];
};


export type QueryAuthMsApiCredentialsArgs = {
  filter: ApiCredentialFilterRq;
};


export type QueryAuthMsApiCredentialsPrivateArgs = {
  input: ApiCredentialSpecialFilter;
};


export type QueryAuthMsAuthSettingsArgs = {
  input?: InputMaybe<AuthSettingsFilter>;
};


export type QueryAuthMsCompanyArgs = {
  input?: InputMaybe<CompanyFilter>;
};


export type QueryAuthMsGetFirebaseIdTokenArgs = {
  uid: Scalars['String']['input'];
};


export type QueryAuthMsMemberArgs = {
  input?: InputMaybe<UserMemberQueryCriteria>;
};


export type QueryAuthMsMerchantArgs = {
  input?: InputMaybe<MerchantFilter>;
};


export type QueryAuthMsPermissionArgs = {
  filter: PermissionFilter;
};


export type QueryAuthMsRoleArgs = {
  filter: RoleFilter;
};


export type QueryAuthMsSignatureCheckerArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuthMsSignatureCreateArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuthMsTokenValidatonArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuthMsUserArgs = {
  input?: InputMaybe<UserAdminQueryCriteria>;
};


export type QueryCmsMsAuthorHistoricalSlugArgs = {
  input?: InputMaybe<AuthorHistoricalSlugCriteria>;
};


export type QueryCmsMsBookmarksArgs = {
  input?: InputMaybe<BookmarksQueryCriteria>;
};


export type QueryCmsMsCommentReactionsArgs = {
  filter: CmsReactionCriteria;
};


export type QueryCmsMsFindPostCommentReactionByHistSlugArgs = {
  urlKey: Scalars['String']['input'];
};


export type QueryCmsMsLockedPostArgs = {
  input?: InputMaybe<CmsLockPostQueryCriteria>;
};


export type QueryCmsMsPostCommentsArgs = {
  input?: InputMaybe<CmsPostCommentFilter>;
};


export type QueryCmsMsPostExtsArgs = {
  input: CmsPostExtQueryCriteria;
};


export type QueryCmsMsPostHistoricalSlugArgs = {
  input: PostHistoricalSlugCriteria;
};


export type QueryCmsMsPostTermRelationshipArgs = {
  filter?: InputMaybe<CmsPostTermRelationshipQueryCriteria>;
};


export type QueryCmsMsPostTermsArgs = {
  filter: CmsPostTermFilter;
  isHome: Scalars['Boolean']['input'];
};


export type QueryCmsMsPostViewsArgs = {
  filter: CmsPostViewsCriteria;
};


export type QueryCmsMsPostsArgs = {
  filter: CmsPostFilter;
};


export type QueryCmsMsPostsPublicArgs = {
  filter: CmsPostFilterPublic;
  isHome?: Scalars['Boolean']['input'];
  isViewCount?: Scalars['Boolean']['input'];
};


export type QueryCmsMsUsersArgs = {
  filter: CmsUserFilter;
};


export type QueryConsentMsHistoryAgreementArgs = {
  input?: InputMaybe<HistoryAgreementQueryCriteria>;
};


export type QueryConsentMsTableAgreementArgs = {
  input?: InputMaybe<AgreementQueryCriteria>;
};


export type QueryConsentMsUserConsentArgs = {
  input?: InputMaybe<UserConsentCriteria>;
};


export type QueryFileMgmtSysMsFetchFileArgs = {
  fileGuids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryFileMgmtSysMsFileMetadataArgs = {
  input?: InputMaybe<TempFileRequest>;
};


export type QueryFileMgmtSysMsFileQuotaArgs = {
  input?: InputMaybe<TempFileRequest>;
};


export type QueryFileMgmtSysMsFileSearchArgs = {
  input?: InputMaybe<TempFileRequest>;
};


export type QueryGgwMsGameTransactionsArgs = {
  input?: InputMaybe<GameTransactionQueryCriteria>;
};


export type QueryGgwMsRequiredFieldArgs = {
  data?: InputMaybe<RequiredFieldRequest>;
};


export type QueryHumanResourcesMsVacancyArgs = {
  input?: InputMaybe<VacancyQueryCriteria>;
};


export type QueryHumanResourcesMsVacancyApplicationArgs = {
  input?: InputMaybe<VacancyApplicationQueryCriteria>;
};


export type QueryHumanResourcesMsVacancyPublicArgs = {
  input?: InputMaybe<VacancyQueryCriteria>;
};


export type QueryHumanResourcesMsVacancySettingsArgs = {
  input?: InputMaybe<VacancySettingsQueryCriteria>;
};


export type QueryMembershipMsBirthdayTierBonusRulesArgs = {
  input?: InputMaybe<BirthdayTierBonusRuleCriteria>;
};


export type QueryMembershipMsCatalogCategoriesArgs = {
  input?: InputMaybe<CatalogCategoryCriteria>;
};


export type QueryMembershipMsCatalogsArgs = {
  input?: InputMaybe<CatalogCriteria>;
};


export type QueryMembershipMsMemberArgs = {
  input?: InputMaybe<MemberCriteria>;
};


export type QueryMembershipMsMemberPointMutationsArgs = {
  input?: InputMaybe<MemberPointMutationCriteria>;
};


export type QueryMembershipMsMemberPointSummaryArgs = {
  input?: InputMaybe<MemberPointSummaryCriteria>;
};


export type QueryMembershipMsMemberPointsArgs = {
  input?: InputMaybe<MemberPointCriteria>;
};


export type QueryMembershipMsRedeemTransactionsArgs = {
  input?: InputMaybe<RedeemTransactionCriteria>;
};


export type QueryMembershipMsRewardPointPredictionArgs = {
  input?: InputMaybe<NewMemberPoint>;
};


export type QueryMembershipMsTierBonusRuleArgs = {
  input?: InputMaybe<TierBonusRuleCriteria>;
};


export type QueryMembershipMsTiersArgs = {
  input?: InputMaybe<TiersCriteria>;
};


export type QueryNotificationMsEmailMessageTemplateArgs = {
  input?: InputMaybe<EmailMsgTemplateCriteria>;
};


export type QueryNotificationMsNotificationAlertsArgs = {
  input?: InputMaybe<NotificationAlertCriteria>;
};


export type QueryProductMsContractTemplateDetailsArgs = {
  input?: InputMaybe<ContractTemplateDetailCriteria>;
};


export type QueryProductMsContractTemplatesArgs = {
  input?: InputMaybe<ContractTemplateCriteria>;
};


export type QueryProductMsMerchantContractsArgs = {
  input?: InputMaybe<MerchantContractCriteria>;
};


export type QueryProductMsPaymentChannelArgs = {
  input?: InputMaybe<PaymentChannelQueryCriteria>;
};


export type QueryProductMsPaymentChannelDenominationArgs = {
  input?: InputMaybe<PaymentChannelDenomQueryCriteria>;
};


export type QueryProductMsPaymentChannelGuidelineArgs = {
  filter?: InputMaybe<PaymentChannelGuidelineQueryCriteria>;
};


export type QueryProductMsPaymentChannelPublicArgs = {
  input?: InputMaybe<PaymentChannelQueryCriteria>;
};


export type QueryProductMsPaymentProviderArgs = {
  input?: InputMaybe<PaymentProviderQueryCriteria>;
};


export type QueryProductMsProductDenominationArgs = {
  input?: InputMaybe<ProductDenominationQueryCriteria>;
};


export type QueryProductMsProductPageArgs = {
  input?: InputMaybe<ProductPageQueryCriteria>;
};


export type QueryProductMsProductPagePublicArgs = {
  input?: InputMaybe<ProductPageQueryCriteriaPublic>;
};


export type QueryProductMsProductPriceListArgs = {
  input: ProductPriceListCriteria;
};


export type QueryProductMsRateCardTemplatesArgs = {
  input?: InputMaybe<RateCardTemplateCriteria>;
};


export type QuerySecretMsCredentialTrailsArgs = {
  input?: InputMaybe<CredentialFilter>;
};


export type QuerySecretMsCredentialsArgs = {
  input?: InputMaybe<CredentialFilter>;
};


export type QueryVoucherMsGatewayCreateOrderArgs = {
  input?: InputMaybe<GatewayCreateOrderRq>;
};


export type QueryVoucherMsVoucherGroupArgs = {
  input?: InputMaybe<VoucherGroupFilter>;
};


export type QueryVoucherMsVoucherGroupAutoGenArgs = {
  input?: InputMaybe<VoucherGroupAutoGenFilter>;
};


export type QueryVoucherMsVoucherGroupAutoGenLockArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVoucherMsVouchersArgs = {
  input?: InputMaybe<VoucherFilter>;
};


export type QueryWebConfigMsCountryArgs = {
  input: CountryQueryCriteria;
};


export type QueryWebConfigMsCurrencyArgs = {
  input: CurrencyQueryCriteria;
};


export type QueryWebConfigMsWebConfigArgs = {
  input: WebConfigQueryCriteria;
};


export type QueryWebtopupMsGetProductPageArgs = {
  productGuid: Scalars['String']['input'];
};


export type QueryWebtopupMsTransactionHistoryArgs = {
  userGuid: Scalars['String']['input'];
};


export type QueryWebtopupMsTransactionsArgs = {
  input: WebtopupTransactionQueryCriteria;
};

export type RateCardTemplate = {
  __typename?: 'RateCardTemplate';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  details?: Maybe<Array<Maybe<RateTemplateDetail>>>;
  guid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type RateCardTemplateCriteria = {
  code?: InputMaybe<Scalars['String']['input']>;
  detailCriteria?: InputMaybe<RateTemplateDetailCriteria>;
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status?: Status;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export enum RateLogic {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type RateTemplateDetail = {
  __typename?: 'RateTemplateDetail';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  magnifyValue?: Maybe<Scalars['Int']['output']>;
  minimumRate?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentProviderCode?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  rateLogic?: Maybe<RateLogic>;
  revision?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RateTemplateDetailCriteria = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentProviderCode?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  rateLogic?: InputMaybe<RateLogic>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: Status;
};

export type RateTemplateRs = {
  __typename?: 'RateTemplateRs';
  data?: Maybe<Array<Maybe<RateCardTemplate>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum ReactionType {
  Heart = 'HEART',
  Like = 'LIKE'
}

export type RedeemTransaction = {
  __typename?: 'RedeemTransaction';
  amount?: Maybe<Scalars['Float']['output']>;
  catalog?: Maybe<Catalog>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  revision?: Maybe<Scalars['String']['output']>;
  trails?: Maybe<Array<Maybe<RedeemTransactionTrail>>>;
  transactionRef?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RedeemTransactionCriteria = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  catalogGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  catalogName?: InputMaybe<Scalars['String']['input']>;
  countryCodes?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  memberGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  transactionRefs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RedeemTransactionRs = {
  __typename?: 'RedeemTransactionRs';
  data?: Maybe<Array<Maybe<RedeemTransaction>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type RedeemTransactionTrail = {
  __typename?: 'RedeemTransactionTrail';
  createdAt?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<EventType>;
  guid?: Maybe<Scalars['String']['output']>;
  internalRemark?: Maybe<Scalars['String']['output']>;
  internalStatus?: Maybe<InternalStatus>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TrailStatus>;
  transactionGuid?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type RegistrationRq = {
  /**  ... user extension, ex: profile photo, bio, etc */
  appLoginSubjectExt?: InputMaybe<Array<InputMaybe<AppLoginSubjectExtRq>>>;
  /**  ... date with format YYYY-MM-DD */
  birthday: Scalars['Date']['input'];
  /**  ... email to register user [Optional] */
  email?: InputMaybe<Scalars['String']['input']>;
  /**  ... user gender */
  gender: Gender;
  /**  ... mobile nunber to register user [Optional] */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  /**  ... user full name */
  name: Scalars['String']['input'];
  /**  ... password for new user */
  password: Scalars['String']['input'];
  /**  ... user pin number */
  pinNumber?: InputMaybe<Scalars['String']['input']>;
  /**  ... referal code */
  referralCode?: InputMaybe<Scalars['String']['input']>;
  /**  ... source platform for bo or public user separation */
  sourcePlatform: SourcePlatform;
};

export enum RegistrationStatus {
  ConfirmationSuccess = 'CONFIRMATION_SUCCESS',
  EmailVerificationSuccess = 'EMAIL_VERIFICATION_SUCCESS',
  MobileVerificationSuccess = 'MOBILE_VERIFICATION_SUCCESS'
}

export type RequiredField = {
  content: RequiredFieldContentEnum;
  name?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  type: RequiredFieldTypeEnum;
  url?: InputMaybe<Scalars['String']['input']>;
  values: Array<RequiredFieldDropdownPair>;
};

export enum RequiredFieldContentEnum {
  Alphabet = 'ALPHABET',
  Alphanumeric = 'ALPHANUMERIC',
  Api = 'API',
  Numeric = 'NUMERIC',
  Static = 'STATIC'
}

export type RequiredFieldDropdownPair = {
  display: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RequiredFieldRequest = {
  gameId?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

export type RequiredFieldResponse = {
  __typename?: 'RequiredFieldResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export enum RequiredFieldTypeEnum {
  Dropdown = 'DROPDOWN',
  Text = 'TEXT'
}

export type RoleFilter = {
  /**  ... to filter role by code equal */
  code?: InputMaybe<Scalars['String']['input']>;
  /**  ...to get role with all guids */
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /**  ... to filter role by name ilike */
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  /** ... to filter role by status equal */
  status?: Status;
  /**  ... to get list of role attached to user */
  subjectGuid?: InputMaybe<Scalars['String']['input']>;
};

export enum Status {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  VerseData = 'VERSE_DATA'
}

export type SignatureCheckerRs = {
  __typename?: 'SignatureCheckerRs';
  status?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SignatureCreateRs = {
  __typename?: 'SignatureCreateRs';
  status?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SocialLoginRq = {
  idToken: Scalars['String']['input'];
  providerPlatform: ProviderPlatform;
  sourcePlatform: SourcePlatform;
};

export enum SourcePlatform {
  /**  ... for backoffice */
  Admin = 'ADMIN',
  /**  ... for public */
  CpCommerce = 'CP_COMMERCE'
}

export enum SuggestedAction {
  /**  ... suggested action if user didn't change password for x month */
  ChangePassword = 'CHANGE_PASSWORD',
  /**  ... default action */
  Default = 'DEFAULT'
}

export type SuspiciousFilter = {
  actionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: Scalars['String']['input'];
  targetCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SuspiciousTag = {
  __typename?: 'SuspiciousTag';
  actionCode?: Maybe<Scalars['String']['output']>;
  actionJson?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  intervalParam?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetCode?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SuspiciousTagPageableRs = {
  __typename?: 'SuspiciousTagPageableRs';
  data?: Maybe<Array<Maybe<SuspiciousTag>>>;
  totalRecord: Scalars['Int']['output'];
};

export type TempFileRequest = {
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type TemporaryUserDeactivationRq = {
  /**  ... band type refer to UserBansType enum */
  banType: UserBanType;
  /**  ... ban exipred at with format "2023-09-01T12:00:00.000Z" or "2023-09-30T12:00:00.000+07:00" */
  expiredAt?: InputMaybe<Scalars['String']['input']>;
  /**  ... admin remark */
  remark?: InputMaybe<Scalars['String']['input']>;
  /**  ... user guid to deactive */
  userGuid: Scalars['String']['input'];
};

export enum TermType {
  Category = 'CATEGORY',
  PostTag = 'POST_TAG'
}

export type TestResult = {
  __typename?: 'TestResult';
  result?: Maybe<Scalars['String']['output']>;
};

export type Tier = {
  __typename?: 'Tier';
  benefitField?: Maybe<Scalars['JSON']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  exts?: Maybe<Array<Maybe<TierExt>>>;
  guid?: Maybe<Scalars['String']['output']>;
  levelValue?: Maybe<Scalars['Int']['output']>;
  minPointToKeep?: Maybe<Scalars['Int']['output']>;
  minPointToReach?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TierStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
};

export type TierBonusRule = {
  __typename?: 'TierBonusRule';
  baseValue?: Maybe<TierBonusRuleBaseValueEnum>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserGuid?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  isForBirthday?: Maybe<Scalars['Boolean']['output']>;
  isForReferral?: Maybe<Scalars['Boolean']['output']>;
  maximumAmount?: Maybe<Scalars['Long']['output']>;
  minimumAmount?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TierBonusRuleStatusEnum>;
  stopNow?: Maybe<Scalars['Boolean']['output']>;
  tierGuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TierBonusRuleTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserGuid?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum TierBonusRuleBaseValueEnum {
  BaseAmount = 'BASE_AMOUNT',
  PrevAmount = 'PREV_AMOUNT'
}

export type TierBonusRuleCriteria = {
  baseValue?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  isForBirthday?: InputMaybe<Scalars['Boolean']['input']>;
  isForReferral?: InputMaybe<Scalars['Boolean']['input']>;
  maximumAmount?: InputMaybe<Scalars['Long']['input']>;
  minimumAmount?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: TierBonusRuleStatusEnum;
  stopNow?: InputMaybe<Scalars['Boolean']['input']>;
  tierGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TierBonusRuleRs = {
  __typename?: 'TierBonusRuleRs';
  data?: Maybe<Array<Maybe<TierBonusRule>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum TierBonusRuleStatusEnum {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export enum TierBonusRuleTypeEnum {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type TierExt = {
  __typename?: 'TierExt';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByGuid?: Maybe<Scalars['String']['output']>;
  extType?: Maybe<Scalars['String']['output']>;
  extValue?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FetchFileResponse>;
  guid?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByGuid?: Maybe<Scalars['String']['output']>;
};

export type TierRs = {
  __typename?: 'TierRs';
  data?: Maybe<Array<Maybe<Tier>>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum TierStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type TiersCriteria = {
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  minPointToKeep?: InputMaybe<Scalars['Int']['input']>;
  minPointToReach?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: Scalars['String']['input'];
  status?: TierStatus;
};

export type Token = {
  __typename?: 'Token';
  accessToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export enum TrailStatus {
  Fail = 'FAIL',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export type TransactionRefund = {
  __typename?: 'TransactionRefund';
  createdBy?: Maybe<AppLoginSubject>;
  createdByGuid?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<AppLoginSubject>;
  updatedByGuid?: Maybe<Scalars['String']['output']>;
};

export enum UniboxV2RequestType {
  MobileGame = 'MOBILE_GAME',
  Standard = 'STANDARD'
}

export type UpdateApiCredentialRq = {
  activeAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transactionalUserGuid?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAuthSettingRq = {
  /**  ... Setting guid identifier */
  guid: Scalars['String']['input'];
  /**  ... Setting name */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  ... Setting value */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBirthdayTierBonusRule = {
  guid: Scalars['String']['input'];
  revision?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tierGuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BirthdayTierBonusRuleTypeEnum>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBookmarkRq = {
  /** Bookmark Guid. */
  guid?: InputMaybe<Scalars['String']['input']>;
  /** Post Guid that going to be saved. */
  postGuid?: InputMaybe<Scalars['String']['input']>;
  /** User Guid that saving the post. */
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCatalog = {
  /** This will replace current categories */
  categoryGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estDeliveryTimeUnit?: InputMaybe<EstDeliveryTimeUnit>;
  estDeliveryTimeValue?: InputMaybe<Scalars['Int']['input']>;
  guid: Scalars['String']['input'];
  isNeedApproval?: InputMaybe<Scalars['Boolean']['input']>;
  minLevelToReach?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
  revision: Scalars['String']['input'];
  status?: InputMaybe<CatalogStatus>;
};

export type UpdateCatalogCategory = {
  guid: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  revision: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCmsPostExtRq = {
  /** Possible value: CONTENT_IMAGE_POST/SQUARE_THUMBNAIL */
  ext_type?: InputMaybe<Scalars['String']['input']>;
  /** Guid value referencing to Amazon S3 image file */
  ext_value?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  post_guid?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCmsPostRq = {
  authorGuid?: InputMaybe<Scalars['String']['input']>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  commentCount?: InputMaybe<Scalars['Int']['input']>;
  /** Open/Closed post comment status */
  commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** Video thumbnail/Live thumbnail */
  contentOption?: InputMaybe<ContentOption>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Country guid of the post */
  countryGuid?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  guid: Scalars['String']['input'];
  /** Pin or un-pin a post */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Content of the post */
  postBody?: InputMaybe<Scalars['String']['input']>;
  /** Terms-Category guid of the post */
  postCategoryGuid?: InputMaybe<Scalars['String']['input']>;
  /** For SEO purposes. Max length: 160 */
  postMetaDescription?: InputMaybe<Scalars['String']['input']>;
  /** DRAFT/ON_REVIEW/PUBLISHED post status */
  postStatus?: InputMaybe<Scalars['String']['input']>;
  /** Terms-PostTag names of the post */
  postTagNames: Array<InputMaybe<Scalars['String']['input']>>;
  postTitle?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The current revision value is mandatory to update CMS Post */
  revision: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  /** The part of a static URL that describes the post */
  urlKey?: InputMaybe<Scalars['String']['input']>;
  /** Video/Live content option source */
  videoSource?: InputMaybe<Scalars['String']['input']>;
  /** Settings for view count  */
  viewCount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCmsPostTermRq = {
  guid: Scalars['String']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  revision: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  termDescription?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Category/Tag. Ex: Anime & Manga, Profile */
  termName?: InputMaybe<Scalars['String']['input']>;
  termParentGuid?: InputMaybe<Scalars['String']['input']>;
  /** Possible value: CATEGORY/POST_TAG */
  termType: TermType;
  urlKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCmsUserRq = {
  authUserGuid?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedByGuid?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyRq = {
  /**  ... new company code */
  code?: InputMaybe<Scalars['String']['input']>;
  /**  ... new company country */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /**  ... new company description */
  description?: InputMaybe<Scalars['String']['input']>;
  /**  ... new company displayed name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**  ... guid for company want to update */
  guid?: InputMaybe<Scalars['String']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /**  ... new company name */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  ... data version, must match data version in db */
  revision?: InputMaybe<Scalars['String']['input']>;
  /**  ... new company status */
  status?: InputMaybe<Status>;
};

export type UpdateContractTemplateRq = {
  contractDetailsGuidToLink?: InputMaybe<Array<Scalars['String']['input']>>;
  contractDetailsGuidToUnlink?: InputMaybe<Array<Scalars['String']['input']>>;
  guid: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productSelection?: InputMaybe<ProductSelectionEnum>;
  revision: Scalars['String']['input'];
  status?: InputMaybe<Status>;
};

export type UpdateCredentialRq = {
  code?: InputMaybe<Scalars['String']['input']>;
  companyGuid?: InputMaybe<Scalars['String']['input']>;
  guid: Scalars['String']['input'];
  revision: Scalars['String']['input'];
  type?: InputMaybe<CredentialType>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmailMessageTemplateRq = {
  /**  ... message template identifier */
  guid: Scalars['String']['input'];
  /**  ... message id */
  messageId?: InputMaybe<Scalars['String']['input']>;
  /**  ... data version, must match data version in db */
  revision: Scalars['String']['input'];
  /**  ... message template status */
  status?: InputMaybe<Scalars['String']['input']>;
  /**  ... base64 encoded html or message template */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHistoryAgreementRq = {
  content?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  guid: Scalars['String']['input'];
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: Status;
};

export type UpdateMerchantContractRq = {
  code?: InputMaybe<Scalars['String']['input']>;
  contractTemplateGuid?: InputMaybe<Scalars['String']['input']>;
  guid: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revision: Scalars['String']['input'];
  status?: InputMaybe<Status>;
};

export type UpdateMerchantPaymentDenomRq = {
  amount?: InputMaybe<Scalars['Double']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  paymentChannelGuid?: InputMaybe<Scalars['String']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMerchantPaymentProviderRq = {
  guid?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  providerGuid?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMerchantRq = {
  companyGuid?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentChannelDenomRq = {
  amount?: InputMaybe<Scalars['Double']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['Long']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  payamentChannelGuid?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentChannelRq = {
  category?: InputMaybe<Scalars['String']['input']>;
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  charge?: InputMaybe<Scalars['Float']['input']>;
  chargeType?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  companyCredentialGuid?: InputMaybe<Scalars['String']['input']>;
  contractorCompanyGuid?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  credentialGuid?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  isWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmount?: InputMaybe<Scalars['Long']['input']>;
  metaFieldJson?: InputMaybe<Array<InputMaybe<PaymentChannelMetaField>>>;
  minAmount?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameter?: InputMaybe<Scalars['String']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  providerCompanyGuid?: InputMaybe<Scalars['String']['input']>;
  providerPriority?: InputMaybe<Scalars['String']['input']>;
  rateTemplateGuid?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  serviceCompanyGuid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vatPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePaymentProviderRq = {
  category?: InputMaybe<Scalars['String']['input']>;
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<Scalars['Long']['input']>;
  minAmount?: InputMaybe<Scalars['Long']['input']>;
  providerExternalName?: InputMaybe<Scalars['String']['input']>;
  providerInternalName?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePermRq = {
  /**  ... new parent identifier */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /**  ... new permmission code */
  permCode?: InputMaybe<Scalars['String']['input']>;
  /**  ... new permission description */
  permDescription?: InputMaybe<Scalars['String']['input']>;
  /**  ... new permission permission module */
  permModule?: InputMaybe<Scalars['String']['input']>;
  /**  ... new permission name */
  permName?: InputMaybe<Scalars['String']['input']>;
  /**  ... new permission permission scope */
  permScope?: InputMaybe<Scalars['String']['input']>;
  /**  ... new permission type */
  permType?: InputMaybe<Scalars['String']['input']>;
  /**  ... data version, must match data version in db */
  revision: Scalars['String']['input'];
  /**  ... new permission status */
  status?: InputMaybe<Status>;
};

export type UpdatePrincipalRq = {
  /**  ...User principal guid */
  guid?: InputMaybe<Scalars['String']['input']>;
  /**  ... User new Principal */
  newPrincipal: Scalars['String']['input'];
  /**  ... User old principal id */
  oldPrincipal?: InputMaybe<Scalars['String']['input']>;
  /**  ... user guid belong to user that we want change the principal, MANDATORY FOR UPDATE BY ADMIN if user don't have the principal type before */
  userGuid?: InputMaybe<Scalars['String']['input']>;
  /**  ... verification code, ONLY FOR UPDATE BY USER if you send guid when update by ADMIN then the data will not used */
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductDenominationRq = {
  guid?: InputMaybe<Scalars['String']['input']>;
  imagePath?: InputMaybe<Scalars['String']['input']>;
  isAdjustableSellingPrice?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectVoucher?: InputMaybe<Scalars['Boolean']['input']>;
  isVoucherApi?: InputMaybe<Scalars['Boolean']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerProductId?: InputMaybe<Scalars['String']['input']>;
  productPageGuid?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  voucherGroupGuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductPageRq = {
  advanceSearch?: InputMaybe<Scalars['String']['input']>;
  category: ProductPageCategory;
  communityLink?: InputMaybe<Scalars['String']['input']>;
  companyGuid?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  credentialGuid?: InputMaybe<Scalars['String']['input']>;
  downloadLink?: InputMaybe<Scalars['String']['input']>;
  gameCenterImage?: InputMaybe<Scalars['String']['input']>;
  gameChildCode?: InputMaybe<Scalars['String']['input']>;
  gameParentCode?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  huaweiDownloadLink?: InputMaybe<Scalars['String']['input']>;
  iconGuid?: InputMaybe<Scalars['String']['input']>;
  influencerLink?: InputMaybe<Scalars['String']['input']>;
  iosDownloadLink?: InputMaybe<Scalars['String']['input']>;
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isShowOnLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaFieldJson?: InputMaybe<Array<InputMaybe<ProductPageMetaField>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  officialSiteLink?: InputMaybe<Scalars['String']['input']>;
  providerCompanyGuid?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  schemaMarkup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topUpGuidLink?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductPriceListRq = {
  ccyCode?: InputMaybe<Scalars['String']['input']>;
  contractTemplateGuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventCode?: InputMaybe<Scalars['String']['input']>;
  guid: Scalars['String']['input'];
  magnifyValue?: InputMaybe<Scalars['Int']['input']>;
  paymentProviderCode?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
  productPageGuid?: InputMaybe<Scalars['String']['input']>;
  rateTemplateGuid?: InputMaybe<Scalars['String']['input']>;
  revision: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Status>;
  type?: InputMaybe<PriceListType>;
};

export type UpdateProfileRq = {
  /**  ... update user birthday */
  birthday?: InputMaybe<Scalars['Date']['input']>;
  /**  ... update user gender */
  gender?: InputMaybe<Gender>;
  /**  ... user guid we want to update, ONLY FOR UPDATE BY ADMIN if you send guid when update by user then the data will not used */
  guid?: InputMaybe<Scalars['String']['input']>;
  /**  ... update user full name */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  ... user status ACTIVE/INACTIVE, ONLY FOR UPDATE BY ADMIN if you send data when update by user then the data will not used */
  status?: InputMaybe<Status>;
};

export type UpdateRateCardTemplateDetailRq = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  guid: Scalars['String']['input'];
  magnifyValue?: InputMaybe<Scalars['Int']['input']>;
  minimumRate?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentProviderCode?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateLogic?: InputMaybe<RateLogic>;
  revision: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRateCardTemplateRq = {
  code?: InputMaybe<Scalars['String']['input']>;
  guid: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  revision: Scalars['String']['input'];
};

export type UpdateRedeem = {
  guid: Scalars['String']['input'];
  internalStatus: InternalStatus;
  remark?: InputMaybe<Scalars['String']['input']>;
  revision: Scalars['String']['input'];
};

export type UpdateRoleRq = {
  /**  ... new role code */
  code?: InputMaybe<Scalars['String']['input']>;
  /**  ... new role description */
  description?: InputMaybe<Scalars['String']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /**  ... new role name */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  ... data version, must match with data version in db */
  revision: Scalars['String']['input'];
  /**  ... new role status */
  status?: InputMaybe<Status>;
};

export type UpdateSuspiciousTagRq = {
  actionCode?: InputMaybe<Scalars['String']['input']>;
  actionJson?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  intervalParam?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  targetCode?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTemplateDetailRq = {
  amount?: InputMaybe<Scalars['Double']['input']>;
  guid: Scalars['String']['input'];
  paymentProviderGuid?: InputMaybe<Scalars['String']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
  productGuid?: InputMaybe<Scalars['String']['input']>;
  productSelection?: ProductSelectionEnum;
  revision: Scalars['String']['input'];
  status?: InputMaybe<Status>;
};

export type UpdateTier = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  levelValue?: InputMaybe<Scalars['Int']['input']>;
  minPointToKeep?: InputMaybe<Scalars['Int']['input']>;
  minPointToReach?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TierStatus>;
};

export type UpdateTierBonusRule = {
  baseValue?: InputMaybe<TierBonusRuleBaseValueEnum>;
  guid: Scalars['String']['input'];
  isForBirthday?: InputMaybe<Scalars['Boolean']['input']>;
  isForReferral?: InputMaybe<Scalars['Boolean']['input']>;
  maximumAmount?: InputMaybe<Scalars['Long']['input']>;
  minimumAmount?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  revision: Scalars['String']['input'];
  status?: InputMaybe<TierBonusRuleStatusEnum>;
  stopNow?: InputMaybe<Scalars['Boolean']['input']>;
  tierGuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TierBonusRuleTypeEnum>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateVacancyRq = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  requirement?: InputMaybe<Scalars['String']['input']>;
  responsibility?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVacancySettingsRq = {
  guid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateVoucherGroupAutoGenRq = {
  /**  amount of voucher that will auto generate  */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /**  Timeout generation Input number in second  */
  generationTimeout?: InputMaybe<Scalars['Int']['input']>;
  /**  GUID of voucher group auto gen */
  guid?: InputMaybe<Scalars['String']['input']>;
  /**  Minimum stock that will auto generate after reach  */
  minThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**  Status of Voucher Group Auto Gen  */
  status?: InputMaybe<Scalars['String']['input']>;
  /**  GUID of voucher group  */
  voucherGroupGuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVoucherGroupRq = {
  /**  Currency  */
  currency?: InputMaybe<Scalars['String']['input']>;
  /**  Voucher group identifier  */
  guid?: InputMaybe<Scalars['String']['input']>;
  /**  to magnify value above before display to user  */
  magnifyValue?: InputMaybe<Scalars['Int']['input']>;
  /**  Name of voucher group  */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  Voucher that have pin, this one to set the pattern  */
  pinPattern: Scalars['JSON']['input'];
  revision: Scalars['String']['input'];
  /**  Voucher pattern for this voucher group, doesn't affect API type voucher  */
  serialPattern: Scalars['JSON']['input'];
  /**  Type of voucher group  */
  type?: InputMaybe<VoucherGroupType>;
  /**  Voucher price to check when redeem */
  value?: InputMaybe<Scalars['Int']['input']>;
  /**  Code for API type voucher only  */
  voucherApiCode?: InputMaybe<Scalars['String']['input']>;
  voucherPattern?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebConfigRq = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  guid: Scalars['String']['input'];
  jsonValue?: InputMaybe<Scalars['String']['input']>;
  numberValue?: InputMaybe<Scalars['Int']['input']>;
  revision: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UserAdminQueryCriteria = {
  companyGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  ... cannot use this filter if already use optionalRole filter */
  mandatoryRole?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  merchantGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**  ... cannot use this filter if already use mandatoryRole filter */
  optionalRole?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sourcePlatform?: InputMaybe<SourcePlatform>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
};

export enum UserBanType {
  Login = 'LOGIN'
}

export type UserByAdmin = {
  __typename?: 'UserByAdmin';
  password?: Maybe<Scalars['String']['output']>;
  user?: Maybe<AppLoginSubject>;
};

export type UserConfirmRq = {
  /**  ... verification code from email or otp notification */
  code: Scalars['String']['input'];
  /**  ... email registered to user */
  email?: InputMaybe<Scalars['String']['input']>;
  /**  ... mobile number registered to user */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  /**  ... source platform where principal registered */
  sourcePlatform: SourcePlatform;
};

export type UserConsent = {
  __typename?: 'UserConsent';
  guid?: Maybe<Scalars['String']['output']>;
  historyAgreement?: Maybe<HistoryAgreement>;
  userGuid?: Maybe<Scalars['String']['output']>;
};

export type UserConsentCriteria = {
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  historyAgreementGuid?: InputMaybe<Scalars['String']['input']>;
  userGuid?: InputMaybe<Scalars['String']['input']>;
};

export type UserFcm = {
  __typename?: 'UserFcm';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  guid: Scalars['String']['output'];
  userGuid: Scalars['String']['output'];
  userToken: Scalars['String']['output'];
};

export type UserLogin = {
  __typename?: 'UserLogin';
  appLoginExt?: Maybe<Array<Maybe<AppLoginSubjectExt>>>;
  birthday?: Maybe<Scalars['Date']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  sourcePlatform?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Status>;
  updatedDate?: Maybe<Scalars['String']['output']>;
};

export type UserMemberQueryCriteria = {
  /**  ... fill with end cursor id to get next data/page, cannot use this if already use 'before' filter */
  after?: InputMaybe<Scalars['String']['input']>;
  /**  ... fill with start cursor id to get prev data/page, cannot use this if already use 'after' filter */
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  ... cannot use this filter if already use optionalRole filter */
  mandatoryRole?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**  ... cannot use this filter if already use mandatoryRole filter */
  optionalRole?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy: AppLoginSubjectSortByEnum;
  sortDirection?: Scalars['String']['input'];
  sourcePlatform?: InputMaybe<SourcePlatform>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
};

export type Vacancy = {
  __typename?: 'Vacancy';
  countryCode?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<AppLoginSubject>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  requirement?: Maybe<Scalars['String']['output']>;
  responsibility?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<AppLoginSubject>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type VacancyApplication = {
  __typename?: 'VacancyApplication';
  attachment?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  vacancyGuid?: Maybe<Scalars['String']['output']>;
};

export type VacancyApplicationQueryCriteria = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vacancyGuid?: InputMaybe<Scalars['String']['input']>;
};

export type VacancyQueryCriteria = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  requirement?: InputMaybe<Scalars['String']['input']>;
  responsibility?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VacancySettings = {
  __typename?: 'VacancySettings';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<AppLoginSubject>;
  guid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<AppLoginSubject>;
  value?: Maybe<Scalars['String']['output']>;
};

export type VacancySettingsQueryCriteria = {
  guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Voucher = {
  __typename?: 'Voucher';
  activationPin?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBySubjectGuid?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  redeemableFrom?: Maybe<Scalars['DateTime']['output']>;
  redeemableTo?: Maybe<Scalars['DateTime']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  softpin?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBySubjectGuid?: Maybe<Scalars['String']['output']>;
  urlKey?: Maybe<Scalars['String']['output']>;
  voucherGroupGuid?: Maybe<Scalars['String']['output']>;
};

export enum VoucherAction {
  /**  Voucher redeemed  */
  Redeem = 'REDEEM',
  /**  Voucher voided  */
  Void = 'VOID'
}

export type VoucherFilter = {
  activationPin?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  redeemableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  redeemableTo?: InputMaybe<Scalars['DateTime']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  softpin?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  totalRecords?: InputMaybe<Scalars['Boolean']['input']>;
  urlKey?: InputMaybe<Scalars['String']['input']>;
  voucherGroupGuid?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherGatewayResponse = {
  __typename?: 'VoucherGatewayResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type VoucherGroup = {
  __typename?: 'VoucherGroup';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBySubjectGuid?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  magnifyValue?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pinPattern?: Maybe<Scalars['JSON']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  serialPattern?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBySubjectGuid?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  voucherApiCode?: Maybe<Scalars['String']['output']>;
  voucherBuyCount?: Maybe<Scalars['Int']['output']>;
  voucherBuyCountUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  voucherCount?: Maybe<Scalars['Int']['output']>;
  voucherRedeemCount?: Maybe<Scalars['Int']['output']>;
  voucherRedeemCountUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  voucherVoidCount?: Maybe<Scalars['Int']['output']>;
  voucherVoidCountUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VoucherGroupAutoGen = {
  __typename?: 'VoucherGroupAutoGen';
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  generationTimeout?: Maybe<Scalars['Int']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  minThreshold?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  voucherGroupGuid?: Maybe<Scalars['String']['output']>;
};

export type VoucherGroupAutoGenFilter = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalRecords?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  voucherGroupGuid?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherGroupAutoGenLock = {
  __typename?: 'VoucherGroupAutoGenLock';
  /**  Same with Voucher Group Auto Gen Guid  */
  guid?: Maybe<Scalars['String']['output']>;
  lockTime?: Maybe<Scalars['DateTime']['output']>;
};

export type VoucherGroupAutoGenLockRq = {
  /**  Same with Voucher Group Auto Gen Guid  */
  guid?: InputMaybe<Scalars['String']['input']>;
  lockTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VoucherGroupAutoGenRs = {
  __typename?: 'VoucherGroupAutoGenRs';
  data: Array<Maybe<VoucherGroupAutoGen>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type VoucherGroupFilter = {
  createdByGuid?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  magnifyValue?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pinPattern?: InputMaybe<Scalars['JSON']['input']>;
  serialPattern?: InputMaybe<Scalars['JSON']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalRecords?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<VoucherGroupType>;
  updatedByGuid?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
  voucherApiCode?: InputMaybe<Scalars['String']['input']>;
  voucherCount?: InputMaybe<Scalars['Int']['input']>;
};

export type VoucherGroupRs = {
  __typename?: 'VoucherGroupRs';
  data: Array<Maybe<VoucherGroup>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export enum VoucherGroupType {
  /**  Call third party API Type */
  Api = 'API',
  /**  Generated voucher type  */
  Generated = 'GENERATED',
  /**  Imported voucher type  */
  Import = 'IMPORT'
}

/**  Voucher Identifier for Redeem  */
export type VoucherId = {
  guid?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type VouchersRs = {
  __typename?: 'VouchersRs';
  data: Array<Maybe<Voucher>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type WebConfig = {
  __typename?: 'WebConfig';
  code?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<AppLoginSubject>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  jsonValue?: Maybe<Scalars['String']['output']>;
  numberValue?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<AppLoginSubject>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type WebConfigQueryCriteria = {
  code?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  jsonValue?: InputMaybe<Scalars['String']['input']>;
  numberValue?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type WebConfigResult = {
  __typename?: 'WebConfigResult';
  data: Array<Maybe<WebConfig>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type WebtopupRequest = {
  countryCode: Scalars['String']['input'];
  currencyCode: Scalars['String']['input'];
  gameFieldJson?: InputMaybe<GameRequiredFieldInput>;
  lang?: InputMaybe<Scalars['String']['input']>;
  magnifyValue: Scalars['Int']['input'];
  paymentProviderCode: Scalars['String']['input'];
  productDenomGuid: Scalars['String']['input'];
  productGuid: Scalars['String']['input'];
  providerAmount: Scalars['Int']['input'];
  type?: InputMaybe<UniboxV2RequestType>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type WebtopupResponse = {
  __typename?: 'WebtopupResponse';
  message?: Maybe<Scalars['String']['output']>;
  paymentGatewayRef?: Maybe<Scalars['String']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  webtopupRef?: Maybe<Scalars['String']['output']>;
};

export type WebtopupTransaction = {
  __typename?: 'WebtopupTransaction';
  companyGuid?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  gameFieldJson?: Maybe<Scalars['JSON']['output']>;
  gameGatewayRef?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  isTesting?: Maybe<Scalars['Boolean']['output']>;
  magnifyValue?: Maybe<Scalars['Int']['output']>;
  merchantGuid?: Maybe<Scalars['String']['output']>;
  paymentFieldJson?: Maybe<Scalars['JSON']['output']>;
  paymentGatewayRef?: Maybe<Scalars['String']['output']>;
  paymentProviderCode?: Maybe<Scalars['String']['output']>;
  paymentProviderGuid?: Maybe<Scalars['String']['output']>;
  productDenomGuid?: Maybe<Scalars['String']['output']>;
  productGuid?: Maybe<Scalars['String']['output']>;
  providerAmount?: Maybe<Scalars['Int']['output']>;
  sourceIp?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userGuid?: Maybe<Scalars['String']['output']>;
  webtopupRef?: Maybe<Scalars['String']['output']>;
};

export type WebtopupTransactionHistory = {
  __typename?: 'WebtopupTransactionHistory';
  gameDetail?: Maybe<GameTransactions>;
  gameGatewayRef?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  paymentGatewayRef?: Maybe<Scalars['String']['output']>;
  webtopupRef?: Maybe<Scalars['String']['output']>;
};

export type WebtopupTransactionQueryCriteria = {
  companyGuid?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  gameGatewayRef?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['String']['input']>;
  merchantGuid?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paymentGatewayRef?: InputMaybe<Scalars['String']['input']>;
  paymentProviderCode?: InputMaybe<Scalars['String']['input']>;
  productDenomGuid?: InputMaybe<Scalars['String']['input']>;
  productGuid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalRecord?: InputMaybe<Scalars['Boolean']['input']>;
  webtopupRef?: InputMaybe<Scalars['String']['input']>;
};

export type WebtopupTransactionResult = {
  __typename?: 'WebtopupTransactionResult';
  data: Array<Maybe<WebtopupTransaction>>;
  totalRecord?: Maybe<Scalars['Int']['output']>;
};

export type IsSuccess = {
  __typename?: 'isSuccess';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};
